// V5 (2026-09-03): Version 8.3 design browser script (experimental-v8-app.js, whose code equals the 8.3 prototype) generated by projects/2026_09_03_Coloring_Blanket_V5/scripts/build-v5.js with the 12 patches listed in scripts/lab-js-patches.js. Do not edit by hand.
(() => {
  const discoveryScene = document.querySelector('.story-scene--alpine');
  const closingScene = document.querySelector('.story-scene--island');
  const discoveryPaper = document.querySelector('.paper--products');
  const closingPaper = document.querySelector('.paper--closing');

  if (discoveryScene && closingScene && discoveryPaper && closingPaper) {
    discoveryScene.append(discoveryPaper);
    closingScene.append(closingPaper);
    discoveryScene.setAttribute('aria-labelledby', 'shop-title');
    closingScene.setAttribute('aria-labelledby', 'closing-title');
    const closingLink = closingPaper.querySelector('[data-closing-browser-link]');
    if (closingLink) {
      closingLink.href = '#how-it-works';
      const label = closingLink.querySelector('span');
      if (label) label.textContent = 'Back to design browser';
    }
  }

  // V5 (2026-09-04, Gus): the card and tile action buttons are gone; the static relabel loop went with them.

  const unifiedMarker = Object.freeze({
    src: window.DVIY_EXPERIMENTAL_V8_MARKER_URL || 'assets/reveal/fabric-marker-cursor-orange-cap-tip-swash.png',
    width: 190,
    height: 145,
    hotspotX: 2,
    hotspotY: 57,
  });

  const markerVisualOwnership = {
    productOwner: null,
    storyOwner: null,
    storyControllers: new Set(),
    sharedMarker: null,
    sharedMarkerHome: null,

    registerStory(controller) {
      this.storyControllers.add(controller);
      if (!this.storyOwner) this.claimStory(controller);
      this.refreshStoryOwner();
    },

    unregisterStory(controller) {
      if (this.sharedMarkerHome?.controller === controller && this.productOwner) {
        this.releaseProduct(this.productOwner);
      }
      this.storyControllers.delete(controller);
      if (this.storyOwner === controller) {
        this.storyOwner = null;
        this.refreshStoryOwner();
      }
    },

    hasProductOwner() {
      return Boolean(this.productOwner);
    },

    claimStory(controller) {
      if (!this.storyControllers.has(controller) || this.storyOwner === controller) return;
      this.storyOwner = controller;
      this.storyControllers.forEach((storyController) => {
        storyController.frame.classList.toggle(
          'is-background-marker-owner',
          storyController === controller,
        );
      });
    },

    refreshStoryOwner() {
      const visibleControllers = [...this.storyControllers]
        .map((controller) => {
          const rect = controller.frame.getBoundingClientRect();
          const visibleHeight = Math.max(
            0,
            Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0),
          );
          return { controller, visibleHeight };
        })
        .filter(({ visibleHeight }) => visibleHeight > 0)
        .sort((a, b) => b.visibleHeight - a.visibleHeight);
      if (visibleControllers.length) this.claimStory(visibleControllers[0].controller);
    },

    claimProduct(controller) {
      if (this.productOwner === controller) return this.sharedMarker;

      const productScene = controller.frame.closest('[data-story-reveal]');
      const productStory = [...this.storyControllers].find(
        (storyController) => storyController.frame === productScene,
      );
      if (productStory) this.claimStory(productStory);
      else this.refreshStoryOwner();

      const previousOwner = this.productOwner;
      previousOwner?.hideMarkerForOwnershipHandoff();

      if (!this.sharedMarker) {
        const homeController = this.storyOwner;
        const marker = homeController?.marker;
        if (!marker?.parentNode) return null;
        this.sharedMarker = marker;
        this.sharedMarkerHome = {
          controller: homeController,
          parent: marker.parentNode,
          nextSibling: marker.nextSibling,
          ariaHidden: marker.getAttribute('aria-hidden'),
          tabIndex: marker.getAttribute('tabindex'),
        };
      }

      this.productOwner = controller;
      document.documentElement.classList.add('is-product-marker-active');
      this.storyControllers.forEach((storyController) => {
        storyController.suspendMarkerForProduct();
      });

      this.sharedMarker.classList.add('is-marker-suppressed');
      this.sharedMarker.classList.add('product-card__reveal-marker', 'is-shared-product-marker');
      this.sharedMarker.setAttribute('aria-hidden', 'true');
      this.sharedMarker.setAttribute('tabindex', '-1');
      this.sharedMarker.style.visibility = 'hidden';
      this.sharedMarker.style.transform = 'translate3d(-120px, -120px, 0)';
      controller.frame.append(this.sharedMarker);
      return this.sharedMarker;
    },

    restoreSharedMarker({ suppressHome = true } = {}) {
      if (!this.sharedMarker || !this.sharedMarkerHome) return;
      const marker = this.sharedMarker;
      const { controller, parent, nextSibling, ariaHidden, tabIndex } = this.sharedMarkerHome;

      marker.classList.toggle('is-marker-suppressed', suppressHome);
      marker.classList.remove('product-card__reveal-marker', 'is-shared-product-marker');
      marker.style.visibility = '';
      marker.style.transform = '';
      if (ariaHidden === null) marker.removeAttribute('aria-hidden');
      else marker.setAttribute('aria-hidden', ariaHidden);
      if (tabIndex === null) marker.removeAttribute('tabindex');
      else marker.setAttribute('tabindex', tabIndex);

      if (nextSibling?.parentNode === parent) parent.insertBefore(marker, nextSibling);
      else parent.append(marker);
      controller.resetMarkerPosition();
      this.sharedMarker = null;
      this.sharedMarkerHome = null;
    },

    releaseProduct(controller, options = {}) {
      if (this.productOwner !== controller) return;
      const homeController = this.sharedMarkerHome?.controller || null;
      const suppressHome = options.suppressHome ?? true;
      controller.hideMarkerForOwnershipHandoff();
      this.productOwner = null;
      document.documentElement.classList.remove('is-product-marker-active');
      this.restoreSharedMarker({ suppressHome });
      this.storyControllers.forEach((storyController) => {
        storyController.resumeMarkerAfterProduct({
          suppress: storyController === homeController && suppressHome,
        });
      });
      this.refreshStoryOwner();
    },
  };

  class StorySceneReveal {
    constructor(frame) {
      this.config = Object.freeze({
        markerMoveThreshold: 8,
      });
      this.frame = frame;
      this.source = frame.querySelector('[data-reveal-source]');
      this.canvas = frame.querySelector('[data-reveal-canvas]');
      this.marker = frame.querySelector('[data-reveal-marker]');
      this.context = this.canvas?.getContext('2d', { alpha: true });
      this.mask = document.createElement('canvas');
      this.maskContext = this.mask.getContext('2d', { alpha: true });
      this.points = [];
      this.starterPolygons = [];
      this.lastPoint = null;
      this.activePointer = null;
      this.touchPointers = new Set();
      this.touchPositions = new Map();
      this.twoTouchLastCentroid = null;
      this.twoTouchStartScrollY = null;
      this.twoTouchStartCentroidY = null;
      this.twoTouchScroll = false;
      this.pointerStart = null;
      this.colorPromise = null;
      this.colorReady = false;
      this.renderFrame = 0;
      this.intersectionObserver = null;
      this.resizeObserver = null;
      this.starterSeeded = false;

      if (!this.source || !this.canvas || !this.marker || !this.context || !this.maskContext) {
        frame.classList.add('is-reveal-unavailable');
        frame.dataset.revealState = 'unavailable';
        return;
      }

      this.onPointerEnter = this.onPointerEnter.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerEnd = this.onPointerEnd.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onMarkerKeyDown = this.onMarkerKeyDown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.resize = this.resize.bind(this);

      frame.dataset.revealState = 'idle';
      frame.dataset.revealPoints = '0';
      frame.dataset.revealInteraction = 'marker-ready';
      this.marker.setAttribute('role', 'button');
      this.marker.setAttribute('tabindex', '0');
      this.marker.setAttribute('aria-label', 'Drag to color. Grab the marker to color this scene');
      this.marker.setAttribute('aria-pressed', 'false');
      this.marker.removeAttribute('aria-hidden');
      this.status = document.createElement('span');
      this.status.className = 'visually-hidden';
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.status.textContent = 'Color marker ready. Touch the marker to color; touch elsewhere to scroll.';
      frame.append(this.status);
      markerVisualOwnership.registerStory(this);
      frame.addEventListener('pointerenter', this.onPointerEnter);
      frame.addEventListener('pointermove', this.onPointerMove);
      frame.addEventListener('pointerdown', this.onPointerDown);
      frame.addEventListener('pointerup', this.onPointerEnd);
      frame.addEventListener('pointercancel', this.onPointerEnd);
      frame.addEventListener('pointerleave', this.onPointerLeave);
      this.marker.addEventListener('keydown', this.onMarkerKeyDown);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.resize);
        this.resizeObserver.observe(frame);
      } else {
        window.addEventListener('resize', this.resize);
      }

      this.resize();
      this.seedStarterReveal();
      const saveData = Boolean(navigator.connection?.saveData);
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.ensureColor();
            this.intersectionObserver?.disconnect();
            this.intersectionObserver = null;
          },
          { rootMargin: saveData ? '0px' : '75% 0px 75% 0px' },
        );
        this.intersectionObserver.observe(frame);
      } else {
        this.ensureColor();
      }
    }

    ensureColor() {
      if (this.colorPromise) return this.colorPromise;

      this.frame.dataset.revealState = 'loading';
      this.colorPromise = new Promise((resolve, reject) => {
        const cleanup = () => {
          this.source.removeEventListener('load', onLoad);
          this.source.removeEventListener('error', onError);
        };
        const onLoad = () => {
          cleanup();
          resolve();
        };
        const onError = () => {
          cleanup();
          reject(new Error(`Could not load the ${this.frame.dataset.revealScene} color layer.`));
        };

        this.source.addEventListener('load', onLoad);
        this.source.addEventListener('error', onError);
        this.source.sizes = this.source.dataset.sizes || '100vw';
        this.source.srcset = this.source.dataset.srcset || '';
        this.source.src = this.source.dataset.src;

        if (this.source.complete && this.source.naturalWidth) queueMicrotask(onLoad);
      })
        .then(() => {
          this.colorReady = true;
          this.frame.dataset.revealState = 'ready';
          this.frame.classList.add('is-reveal-ready');
          this.resize();
          return true;
        })
        .catch(() => {
          this.frame.dataset.revealState = 'unavailable';
          this.frame.classList.add('is-reveal-unavailable');
          this.setMarkerVisible(false);
          return false;
        });

      return this.colorPromise;
    }

    resize() {
      const rect = this.canvas.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const density = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(rect.width * density));
      const height = Math.max(1, Math.round(rect.height * density));
      if (this.canvas.width === width && this.canvas.height === height) {
        this.scheduleRender();
        return;
      }

      this.canvas.width = width;
      this.canvas.height = height;
      this.mask.width = width;
      this.mask.height = height;
      this.starterPolygons.forEach((polygon) => this.drawStarterPolygon(polygon));
      this.points.forEach((point) => this.drawMaskPoint(point));
      this.scheduleRender();
    }

    drawMaskPoint(point) {
      const x = point.x * this.mask.width;
      const y = point.y * this.mask.height;
      const radius = point.radius * Math.min(this.mask.width, this.mask.height);
      const gradient = this.maskContext.createRadialGradient(x, y, 0, x, y, radius);
      gradient.addColorStop(0, 'rgb(0 0 0 / 100%)');
      gradient.addColorStop(0.7, 'rgb(0 0 0 / 96%)');
      gradient.addColorStop(1, 'rgb(0 0 0 / 0%)');
      this.maskContext.fillStyle = gradient;
      this.maskContext.fillRect(x - radius, y - radius, radius * 2, radius * 2);
    }

    addPoint(x, y, radius) {
      const point = { x, y, radius };
      if (this.points.length < 60000) this.points.push(point);
      this.drawMaskPoint(point);
    }

    addStarterLine(vertices, radius, addPixelPoint) {
      vertices.slice(1).forEach((vertex, index) => {
        const previous = vertices[index];
        const distance = Math.hypot(vertex[0] - previous[0], vertex[1] - previous[1]);
        const steps = Math.max(1, Math.ceil(distance / Math.max(8, radius * 0.56)));
        for (let step = 0; step <= steps; step += 1) {
          const progress = step / steps;
          addPixelPoint(
            previous[0] + (vertex[0] - previous[0]) * progress,
            previous[1] + (vertex[1] - previous[1]) * progress,
            radius,
          );
        }
      });
    }

    drawStarterPolygon(polygon) {
      if (!polygon.length) return;
      this.maskContext.save();
      this.maskContext.beginPath();
      polygon.forEach((point, index) => {
        const x = point.x * this.mask.width;
        const y = point.y * this.mask.height;
        if (index) this.maskContext.lineTo(x, y);
        else this.maskContext.moveTo(x, y);
      });
      this.maskContext.closePath();
      this.maskContext.fillStyle = 'rgb(0 0 0 / 100%)';
      this.maskContext.shadowColor = 'rgb(0 0 0 / 88%)';
      this.maskContext.shadowBlur = Math.max(4, this.mask.width / 95);
      this.maskContext.fill();
      this.maskContext.restore();
    }

    seedStarterReveal() {
      if (this.starterSeeded) return;
      const starter = this.frame.dataset.revealStarter;
      if (!starter) return;

      const canvasRect = this.canvas.getBoundingClientRect();
      const markerRect = this.marker.getBoundingClientRect();
      if (!canvasRect.width || !canvasRect.height || !markerRect.width || !markerRect.height) return;

      const scale = Math.min(1.22, Math.max(0.82, canvasRect.width / 390));
      const anchorX = markerRect.left - canvasRect.left + Math.min(48, markerRect.width * 0.27);
      const anchorY = markerRect.top - canvasRect.top + markerRect.height * 0.72;
      const firstPoint = this.points.length;
      const addPixelPoint = (offsetX, offsetY, radius) => {
        this.addPoint(
          (anchorX + offsetX * scale) / canvasRect.width,
          (anchorY + offsetY * scale) / canvasRect.height,
          (radius * scale) / Math.min(canvasRect.width, canvasRect.height),
        );
      };
      const addPixelPolygon = (vertices) => {
        const polygon = vertices.map(([offsetX, offsetY]) => ({
          x: (anchorX + offsetX * scale) / canvasRect.width,
          y: (anchorY + offsetY * scale) / canvasRect.height,
        }));
        this.starterPolygons.push(polygon);
        this.drawStarterPolygon(polygon);
      };

      if (starter === 'splash') {
        [
          [-15, 12, 76],
          [-67, 24, 68],
          [-122, 7, 55],
          [-82, 75, 49],
          [-151, 72, 38],
          [-181, 42, 27],
          [-125, -40, 25],
          [-57, -48, 17],
          [-193, -28, 37],
          [-224, -50, 34],
          [-229, -3, 32],
          [-211, 43, 30],
          [-221, 88, 36],
          [-181, 111, 27],
          [116, 7, 45],
          [160, 30, 39],
          [139, 79, 36],
          [-22, 120, 55],
          [-105, 131, 43],
          [72, 122, 40],
        ].forEach(([x, y, radius]) => addPixelPoint(x, y, radius));
      } else if (starter === 'zigzag') {
        this.addStarterLine(
          [
            [116, 20], [78, 72], [28, 43], [-16, 116], [-84, 68],
            [-122, 161], [-204, 103], [-244, 208], [-335, 151],
          ],
          28,
          addPixelPoint,
        );
        this.addStarterLine(
          [[105, 121], [142, 151], [113, 182]],
          17,
          addPixelPoint,
        );
        [
          [122, 52, 31],
          [4, 180, 33],
          [-137, 210, 27],
          [-320, 218, 31],
          [-48, 18, 16],
          [-229, 59, 20],
          [-285, 106, 14],
          [72, 225, 18],
        ].forEach(([x, y, radius]) => addPixelPoint(x, y, radius));
      } else if (starter === 'halo') {
        addPixelPoint(-72, 38, 122);
        addPixelPoint(-153, 57, 68);
        addPixelPoint(16, 83, 54);
        addPixelPoint(-78, 143, 46);
      } else if (starter === 'ribbon') {
        this.addStarterLine(
          [[-4, 2], [-42, 29], [-81, 4], [-120, 40], [-162, 10], [-207, 55]],
          40,
          addPixelPoint,
        );
        addPixelPoint(-236, 73, 23);
        addPixelPoint(-177, -31, 17);
        addPixelPoint(-108, 91, 16);
        addPixelPoint(-35, 109, 19);
      }

      this.starterSeeded = true;
      this.frame.dataset.revealStarterSeeded = 'true';
      this.frame.dataset.revealStarterPoints = String(this.points.length - firstPoint);
      this.frame.dataset.revealStarterPolygons = String(this.starterPolygons.length);
      this.frame.dataset.revealPoints = String(this.points.length);
      this.scheduleRender();
    }

    paintAt(clientX, clientY) {
      const rect = this.canvas.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = (clientX - rect.left) / rect.width;
      const y = (clientY - rect.top) / rect.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) return;

      this.ensureColor();
      const radiusPixels = Math.min(150, Math.max(48, rect.width * 0.17));
      const radius = radiusPixels / Math.min(rect.width, rect.height);
      const previous = this.lastPoint;
      const distance = previous
        ? Math.hypot((x - previous.x) * rect.width, (y - previous.y) * rect.height)
        : 0;
      const steps = previous ? Math.max(1, Math.ceil(distance / (radiusPixels * 0.3))) : 1;

      for (let step = 1; step <= steps; step += 1) {
        const progress = step / steps;
        this.addPoint(
          previous ? previous.x + (x - previous.x) * progress : x,
          previous ? previous.y + (y - previous.y) * progress : y,
          radius,
        );
      }

      this.lastPoint = { x, y };
      this.frame.dataset.revealPoints = String(this.points.length);
      this.scheduleRender();
    }

    drawColorCover() {
      const sourceWidth = this.source.naturalWidth;
      const sourceHeight = this.source.naturalHeight;
      const targetWidth = this.canvas.width;
      const targetHeight = this.canvas.height;
      if (!sourceWidth || !sourceHeight || !targetWidth || !targetHeight) return;

      const scale = Math.max(targetWidth / sourceWidth, targetHeight / sourceHeight);
      const drawWidth = sourceWidth * scale;
      const drawHeight = sourceHeight * scale;
      const positionX = Math.min(1, Math.max(0, Number(this.frame.dataset.revealPositionX) || 0.5));
      const positionY = Math.min(1, Math.max(0, Number(this.frame.dataset.revealPositionY) || 0.5));
      const drawX = (targetWidth - drawWidth) * positionX;
      const drawY = (targetHeight - drawHeight) * positionY;
      this.context.drawImage(this.source, drawX, drawY, drawWidth, drawHeight);
    }

    scheduleRender() {
      if (!this.colorReady || this.renderFrame) return;
      this.renderFrame = requestAnimationFrame(() => {
        this.renderFrame = 0;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.save();
        this.context.globalCompositeOperation = 'source-over';
        this.context.imageSmoothingEnabled = true;
        this.context.imageSmoothingQuality = 'high';
        this.drawColorCover();
        this.context.globalCompositeOperation = 'destination-in';
        this.context.drawImage(this.mask, 0, 0);
        this.context.restore();
      });
    }

    // V5 scene (2026-09-04): the product paper is off-limits for the scene marker and the hover paint.
    isOverProductPaper(event) {
      return event.target instanceof Element && Boolean(event.target.closest('.cbv6-hero-paper, [data-v86-portal-entry], [data-v86-review-dialog]'));
    }

    isInteractiveTarget(target) {
      if (!(target instanceof Element)) return false;
      const interactive = target.closest('a, button, input, select, textarea, [role="button"]');
      return Boolean(interactive && interactive !== this.marker);
    }

    positionMarker(event) {
      this.marker.classList.add('is-marker-direct');
      this.marker.style.transform = 'translate3d(0, 0, 0)';
      const restingRect = this.marker.getBoundingClientRect();
      const art = this.marker.querySelector('.story-reveal__marker-art');
      const artRect = art?.getBoundingClientRect() || restingRect;
      const markerScale = artRect.width / unifiedMarker.width;
      const hotspotX = artRect.left - restingRect.left + unifiedMarker.hotspotX * markerScale;
      const hotspotY = artRect.top - restingRect.top + unifiedMarker.hotspotY * markerScale;
      const x = event.clientX - restingRect.left - hotspotX;
      const y = event.clientY - restingRect.top - hotspotY;
      this.marker.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }

    positionMarkerForTouch(event) {
      if (!this.pointerStart) return;
      const x = event.clientX - this.pointerStart.x;
      const y = event.clientY - this.pointerStart.y;
      this.marker.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }

    setMarkerVisible(visible, event) {
      if (markerVisualOwnership.hasProductOwner()) {
        this.frame.classList.remove('is-reveal-pointing');
        return;
      }

      if (!visible) {
        this.marker.classList.add('is-marker-suppressed');
        this.frame.classList.remove('is-reveal-pointing');
        return;
      }

      if (event) this.positionMarker(event);
      this.marker.classList.remove('is-marker-suppressed');
      this.frame.classList.add('is-reveal-pointing');
    }

    resetMarkerPosition() {
      this.marker.classList.remove('is-marker-direct');
      this.marker.style.left = '';
      this.marker.style.top = '';
      this.marker.style.transform = '';
    }

    suspendMarkerForProduct() {
      this.lastPoint = null;
      this.marker.classList.add('is-marker-suppressed');
      this.frame.classList.remove('is-reveal-pointing');
      if (this.activePointer === null) this.resetMarkerPosition();
    }

    resumeMarkerAfterProduct({ suppress = false } = {}) {
      this.lastPoint = null;
      this.marker.classList.toggle('is-marker-suppressed', suppress);
      if (this.activePointer === null) this.resetMarkerPosition();
    }

    setMarkerSelected(selected, message) {
      this.frame.classList.toggle('is-reveal-marker-selected', selected);
      this.frame.classList.toggle('is-reveal-two-touch', this.twoTouchScroll);
      this.frame.dataset.revealInteraction = this.twoTouchScroll
        ? 'two-finger-scroll'
        : selected
          ? 'marker-coloring'
          : 'marker-ready';
      this.marker.setAttribute('aria-pressed', String(selected));
      if (message) this.status.textContent = message;
      if (!selected) this.resetMarkerPosition();
    }

    onPointerEnter(event) {
      markerVisualOwnership.claimStory(this);
      this.ensureColor();
      if (event.pointerType !== 'mouse') return;
      if (this.isOverProductPaper(event)) {
        this.lastPoint = null;
        this.setMarkerVisible(false);
        return;
      }
      this.paintAt(event.clientX, event.clientY);
      this.setMarkerVisible(!this.isInteractiveTarget(event.target), event);
    }

    onPointerMove(event) {
      markerVisualOwnership.claimStory(this);
      const isMouse = event.pointerType === 'mouse';
      const isActiveDirectPointer = this.activePointer === event.pointerId;
      if (!isMouse && this.twoTouchScroll) {
        this.touchPositions.set(event.pointerId, { x: event.clientX, y: event.clientY });
        const points = [...this.touchPositions.values()];
        const centroid = points.length
          ? {
              x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
              y: points.reduce((sum, point) => sum + point.y, 0) / points.length,
            }
          : null;
        if (centroid && this.twoTouchLastCentroid) {
          const pageDelta = this.twoTouchLastCentroid.y - centroid.y;
          if (pageDelta && event.cancelable) event.preventDefault();
          if (centroid && this.twoTouchStartScrollY !== null && this.twoTouchStartCentroidY !== null) {
            window.scrollTo(
              0,
              this.twoTouchStartScrollY + this.twoTouchStartCentroidY - centroid.y,
            );
          }
        }
        this.twoTouchLastCentroid = centroid;
        return;
      }
      if (!isMouse && !isActiveDirectPointer) return;
      if (!isMouse && this.pointerStart) {
        const distance = Math.hypot(
          event.clientX - this.pointerStart.x,
          event.clientY - this.pointerStart.y,
        );
        if (distance < this.config.markerMoveThreshold) return;
        if (event.cancelable) event.preventDefault();
      }
      if (!isMouse) {
        this.touchPositions.set(event.pointerId, { x: event.clientX, y: event.clientY });
      }
      if (isMouse && this.isOverProductPaper(event)) {
        this.lastPoint = null;
        this.setMarkerVisible(false);
        return;
      }
      this.paintAt(event.clientX, event.clientY);
      if (isMouse) {
        this.setMarkerVisible(!this.isInteractiveTarget(event.target), event);
      } else {
        this.setMarkerVisible(true);
        this.positionMarkerForTouch(event);
      }
    }

    onPointerDown(event) {
      markerVisualOwnership.claimStory(this);
      if (event.pointerType === 'mouse') return;
      this.touchPointers.add(event.pointerId);
      this.touchPositions.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (this.activePointer !== null) {
        this.twoTouchScroll = true;
        const points = [...this.touchPositions.values()];
        this.twoTouchLastCentroid = {
          x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
          y: points.reduce((sum, point) => sum + point.y, 0) / points.length,
        };
        this.twoTouchStartScrollY = window.scrollY;
        this.twoTouchStartCentroidY = this.twoTouchLastCentroid.y;
        this.activePointer = null;
        this.pointerStart = null;
        this.lastPoint = null;
        this.frame.classList.add('is-reveal-two-touch');
        this.frame.dataset.revealInteraction = 'two-finger-scroll';
        this.status.textContent = 'Two-finger scrolling enabled. Release to grab the marker again.';
        return;
      }
      if (this.twoTouchScroll) return;
      if (!this.marker.contains(event.target)) {
        this.touchPointers.clear();
        this.touchPositions.clear();
        return;
      }
      this.activePointer = event.pointerId;
      this.pointerStart = { x: event.clientX, y: event.clientY };
      this.setMarkerSelected(true, 'Marker selected. Drag to color; add a second finger to scroll.');
      this.setMarkerVisible(true);
      this.ensureColor();
    }

    onPointerEnd(event) {
      this.touchPointers.delete(event.pointerId);
      this.touchPositions.delete(event.pointerId);
      if (this.twoTouchScroll && this.touchPointers.size < 2) {
        this.activePointer = null;
        this.pointerStart = null;
        this.twoTouchScroll = false;
        this.twoTouchLastCentroid = null;
        this.twoTouchStartScrollY = null;
        this.twoTouchStartCentroidY = null;
        this.lastPoint = null;
        this.setMarkerSelected(
          false,
          'Two-finger scrolling ended. Release, then grab the marker to color again.',
        );
        return;
      }
      if (this.touchPointers.size) return;
      this.activePointer = null;
      this.pointerStart = null;
      this.twoTouchScroll = false;
      this.twoTouchLastCentroid = null;
      this.twoTouchStartScrollY = null;
      this.twoTouchStartCentroidY = null;
      this.lastPoint = null;
      this.setMarkerSelected(false, 'Color marker ready. Touch the marker to color; touch elsewhere to scroll.');
    }

    onPointerLeave(event) {
      if (event.pointerType === 'mouse') {
        this.lastPoint = null;
        this.setMarkerVisible(false);
        this.resetMarkerPosition();
      }
    }

    onMarkerKeyDown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      markerVisualOwnership.claimStory(this);
      const markerRect = this.marker.getBoundingClientRect();
      const canvasRect = this.canvas.getBoundingClientRect();
      const clientX = Math.min(
        canvasRect.right - 1,
        Math.max(canvasRect.left + 1, markerRect.left + markerRect.width / 2),
      );
      const clientY = Math.min(
        canvasRect.bottom - 1,
        Math.max(canvasRect.top + 1, markerRect.top + markerRect.height / 2),
      );
      this.lastPoint = null;
      this.paintAt(clientX, clientY);
      this.lastPoint = null;
      this.status.textContent = 'Colored one spot. Drag the marker on touch to color a stroke.';
    }

    onScroll() {
      this.lastPoint = null;
      if (this.activePointer === null) {
        if (this.marker.classList.contains('is-marker-direct')) this.setMarkerVisible(false);
        this.resetMarkerPosition();
      }
      markerVisualOwnership.refreshStoryOwner();
    }

    destroy() {
      if (this.renderFrame) cancelAnimationFrame(this.renderFrame);
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.frame.removeEventListener('pointerenter', this.onPointerEnter);
      this.frame.removeEventListener('pointermove', this.onPointerMove);
      this.frame.removeEventListener('pointerdown', this.onPointerDown);
      this.frame.removeEventListener('pointerup', this.onPointerEnd);
      this.frame.removeEventListener('pointercancel', this.onPointerEnd);
      this.frame.removeEventListener('pointerleave', this.onPointerLeave);
      this.marker.removeEventListener('keydown', this.onMarkerKeyDown);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.resize);
      markerVisualOwnership.unregisterStory(this);
    }
  }

  class ProductDesignReveal {
    constructor(frame, pair, productId) {
      this.frame = frame;
      this.pair = pair;
      this.productId = productId;
      this.card = frame.closest('[data-product-card], .design-tile');
      this.link = frame.closest('[data-product-open]');
      this.base = frame.querySelector('.product-card__design, img');
      this.source = document.createElement('img');
      this.canvas = document.createElement('canvas');
      this.marker = null;
      this.context = this.canvas.getContext('2d', { alpha: true });
      this.mask = document.createElement('canvas');
      this.maskContext = this.mask.getContext('2d', { alpha: true });
      this.points = [];
      this.lastPoint = null;
      this.pendingPoint = null;
      this.mouseInside = false;
      this.activePointer = null;
      this.pointerStart = null;
      this.colorPromise = null;
      this.colorReady = false;
      this.activated = false;
      this.renderFrame = 0;
      this.activationTimer = 0;
      this.suppressClickUntil = 0;
      this.resizeObserver = null;
      this.intersectionObserver = null;

      if (!this.card || !this.link || !this.base || !this.context || !this.maskContext) {
        this.setUnavailable();
        return;
      }

      this.onPointerEnter = this.onPointerEnter.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerEnd = this.onPointerEnd.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.resize = this.resize.bind(this);

      this.base.src = pair.baseSrc;
      this.base.width = pair.width;
      this.base.height = pair.height;
      this.source.alt = '';
      this.source.width = pair.width;
      this.source.height = pair.height;
      this.source.decoding = 'async';
      this.source.hidden = true;
      this.source.setAttribute('aria-hidden', 'true');
      this.source.className = 'product-card__reveal-source';
      this.canvas.className = 'product-card__reveal-canvas';
      this.canvas.setAttribute('aria-hidden', 'true');
      this.frame.append(this.source, this.canvas);

      const hint = document.createElement('span');
      hint.className = 'visually-hidden';
      hint.textContent = 'Interactive color preview available.';
      this.link.prepend(hint);

      this.card.dataset.designRevealAvailable = 'true';
      this.frame.dataset.designRevealState = 'loading';
      this.frame.dataset.designRevealPoints = '0';
      this.frame.addEventListener('pointerenter', this.onPointerEnter);
      this.frame.addEventListener('pointermove', this.onPointerMove);
      this.frame.addEventListener('pointerdown', this.onPointerDown);
      this.frame.addEventListener('pointerup', this.onPointerEnd);
      this.frame.addEventListener('pointercancel', this.onPointerEnd);
      this.frame.addEventListener('pointerleave', this.onPointerLeave);
      this.link.addEventListener('click', this.onClickCapture, true);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.resize);
        this.resizeObserver.observe(frame);
      } else {
        window.addEventListener('resize', this.resize);
      }

      this.resize();
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.ensureColor();
            this.intersectionObserver?.disconnect();
            this.intersectionObserver = null;
          },
          { rootMargin: '80% 0px 80% 0px' },
        );
        this.intersectionObserver.observe(frame);
      } else {
        this.ensureColor();
      }
    }

    ensureColor() {
      if (this.colorPromise) return this.colorPromise;
      this.colorPromise = new Promise((resolve, reject) => {
        const cleanup = () => {
          this.source.removeEventListener('load', onLoad);
          this.source.removeEventListener('error', onError);
        };
        const onLoad = () => {
          cleanup();
          resolve();
        };
        const onError = () => {
          cleanup();
          reject(new Error(`Could not load color preview for ${this.productId}.`));
        };
        this.source.addEventListener('load', onLoad);
        this.source.addEventListener('error', onError);
        this.source.src = this.pair.colorSrc;
        if (this.source.complete && this.source.naturalWidth) queueMicrotask(onLoad);
      })
        .then(() => {
          this.colorReady = true;
          this.frame.dataset.designRevealState = this.activated ? 'painting' : 'cue';
          this.frame.classList.add('is-design-reveal-ready');
          this.resize();
          return true;
        })
        .catch(() => {
          this.setUnavailable();
          return false;
        });
      return this.colorPromise;
    }

    setUnavailable() {
      this.frame.dataset.designRevealState = 'unavailable';
      this.frame.classList.add('is-design-reveal-unavailable');
      this.setMarkerVisible(false);
    }

    resize() {
      const rect = this.canvas.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const density = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(rect.width * density));
      const height = Math.max(1, Math.round(rect.height * density));
      if (this.canvas.width === width && this.canvas.height === height) {
        this.scheduleRender();
        return;
      }
      this.canvas.width = width;
      this.canvas.height = height;
      this.mask.width = width;
      this.mask.height = height;
      this.maskContext.clearRect(0, 0, width, height);
      this.points.forEach((point) => this.drawMaskPoint(point));
      this.scheduleRender();
    }

    getInnerRect() {
      const density = this.canvas.width / Math.max(1, this.canvas.getBoundingClientRect().width);
      const styles = getComputedStyle(this.base);
      const left = (Number.parseFloat(styles.paddingLeft) || 0) * density;
      const top = (Number.parseFloat(styles.paddingTop) || 0) * density;
      const right = (Number.parseFloat(styles.paddingRight) || 0) * density;
      const bottom = (Number.parseFloat(styles.paddingBottom) || 0) * density;
      return {
        x: left,
        y: top,
        width: Math.max(1, this.canvas.width - left - right),
        height: Math.max(1, this.canvas.height - top - bottom),
      };
    }

    getColorRect() {
      const inner = this.getInnerRect();
      const sourceWidth = this.source.naturalWidth;
      const sourceHeight = this.source.naturalHeight;
      if (!sourceWidth || !sourceHeight) return null;
      const scale = Math.min(inner.width / sourceWidth, inner.height / sourceHeight);
      const width = sourceWidth * scale;
      const height = sourceHeight * scale;
      return {
        x: inner.x + (inner.width - width) / 2,
        y: inner.y + (inner.height - height) / 2,
        width,
        height,
      };
    }

    drawColorContain(rect = this.getColorRect()) {
      if (!rect) return;
      this.context.drawImage(this.source, rect.x, rect.y, rect.width, rect.height);
    }

    drawCue() {
      const rect = this.getColorRect();
      if (!rect) return;
      this.context.save();
      this.context.beginPath();
      this.context.moveTo(rect.x + rect.width * this.pair.cueTopStart, rect.y);
      this.context.lineTo(rect.x + rect.width, rect.y);
      this.context.lineTo(rect.x + rect.width, rect.y + rect.height * this.pair.cueRightDepth);
      this.context.closePath();
      this.context.clip();
      this.drawColorContain(rect);
      this.context.restore();
    }

    scheduleRender() {
      if (!this.colorReady || this.renderFrame) return;
      this.renderFrame = requestAnimationFrame(() => {
        this.renderFrame = 0;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.save();
        this.context.imageSmoothingEnabled = true;
        this.context.imageSmoothingQuality = 'high';
        if (!this.activated) {
          this.drawCue();
        } else if (this.points.length) {
          this.drawColorContain();
          this.context.globalCompositeOperation = 'destination-in';
          this.context.drawImage(this.mask, 0, 0);
        }
        this.context.restore();
      });
    }

    drawMaskPoint(point) {
      const x = point.x * this.mask.width;
      const y = point.y * this.mask.height;
      const radius = point.radius * Math.min(this.mask.width, this.mask.height);
      const gradient = this.maskContext.createRadialGradient(x, y, 0, x, y, radius);
      gradient.addColorStop(0, 'rgb(0 0 0 / 100%)');
      gradient.addColorStop(0.72, 'rgb(0 0 0 / 96%)');
      gradient.addColorStop(1, 'rgb(0 0 0 / 0%)');
      this.maskContext.fillStyle = gradient;
      this.maskContext.fillRect(x - radius, y - radius, radius * 2, radius * 2);
    }

    addPoint(x, y, radius) {
      const point = { x, y, radius };
      if (this.points.length < 8000) this.points.push(point);
      this.drawMaskPoint(point);
    }

    paintAt(clientX, clientY) {
      if (!this.colorReady || !this.activated) return;
      const rect = this.canvas.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = (clientX - rect.left) / rect.width;
      const y = (clientY - rect.top) / rect.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) return;
      const radiusPixels = Math.min(72, Math.max(28, rect.width * 0.22));
      const radius = radiusPixels / Math.min(rect.width, rect.height);
      const previous = this.lastPoint;
      const distance = previous
        ? Math.hypot((x - previous.x) * rect.width, (y - previous.y) * rect.height)
        : 0;
      const steps = previous ? Math.max(1, Math.ceil(distance / (radiusPixels * 0.3))) : 1;
      for (let step = 1; step <= steps; step += 1) {
        const progress = step / steps;
        this.addPoint(
          previous ? previous.x + (x - previous.x) * progress : x,
          previous ? previous.y + (y - previous.y) * progress : y,
          radius,
        );
      }
      this.lastPoint = { x, y };
      this.frame.dataset.designRevealPoints = String(this.points.length);
      this.frame.dataset.designRevealState = 'painting';
      this.scheduleRender();
    }

    activate(point) {
      this.pendingPoint = point;
      if (this.activated) {
        if (this.activationTimer) return;
        this.paintAt(point.clientX, point.clientY);
        return;
      }
      this.activated = true;
      this.frame.classList.add('is-design-reveal-active');
      this.frame.dataset.designRevealState = 'activating';
      this.scheduleRender();
      const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 90;
      this.activationTimer = window.setTimeout(() => {
        this.activationTimer = 0;
        this.frame.dataset.designRevealState = 'painting';
        if (this.pendingPoint && (this.mouseInside || this.activePointer !== null)) {
          this.paintAt(this.pendingPoint.clientX, this.pendingPoint.clientY);
        }
      }, delay);
    }

    positionMarker(event) {
      if (!this.marker) return;
      const rect = this.canvas.getBoundingClientRect();
      const markerWidth = this.marker.getBoundingClientRect().width || 48;
      const scale = markerWidth / unifiedMarker.width;
      const x = event.clientX - rect.left - unifiedMarker.hotspotX * scale;
      const y = event.clientY - rect.top - unifiedMarker.hotspotY * scale;
      this.marker.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }

    hideMarkerForOwnershipHandoff() {
      this.mouseInside = false;
      this.lastPoint = null;
      this.frame.classList.remove('is-design-reveal-pointing');
      if (this.marker) {
        this.marker.classList.add('is-marker-suppressed');
        this.marker.style.visibility = 'hidden';
        this.marker.style.transform = 'translate3d(-120px, -120px, 0)';
      }
      this.marker = null;
    }

    setMarkerVisible(visible, event) {
      if (visible) {
        this.marker = markerVisualOwnership.claimProduct(this);
        if (!this.marker) return;
        if (event) this.positionMarker(event);
        this.marker.classList.remove('is-marker-suppressed');
        this.marker.style.visibility = 'visible';
        this.frame.classList.add('is-design-reveal-pointing');
        return;
      }
      this.frame.classList.remove('is-design-reveal-pointing');
      markerVisualOwnership.releaseProduct(this, {
        suppressHome: !event?.pointerType || event.pointerType === 'mouse',
      });
      this.marker = null;
    }

    onPointerEnter(event) {
      if (event.pointerType !== 'mouse') return;
      this.mouseInside = true;
      this.ensureColor().then((ready) => {
        if (!ready || !this.mouseInside) return;
        const point = { clientX: event.clientX, clientY: event.clientY };
        this.activate(point);
        this.setMarkerVisible(true, event);
      });
    }

    onPointerMove(event) {
      if (event.pointerType === 'mouse') {
        this.mouseInside = true;
        const point = { clientX: event.clientX, clientY: event.clientY };
        this.pendingPoint = point;
        this.ensureColor().then((ready) => {
          if (!ready || !this.mouseInside) return;
          this.activate(point);
          this.setMarkerVisible(true, event);
        });
        return;
      }
      if (event.pointerId !== this.activePointer || !this.pointerStart) return;
      const distance = Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y);
      if (distance < 10) return;
      this.suppressClickUntil = performance.now() + 700;
      if (event.cancelable) event.preventDefault();
      const point = { clientX: event.clientX, clientY: event.clientY };
      this.pendingPoint = point;
      this.ensureColor().then((ready) => {
        if (!ready) return;
        this.activate(point);
        this.setMarkerVisible(true, event);
      });
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse') return;
      this.activePointer = event.pointerId;
      this.pointerStart = { x: event.clientX, y: event.clientY };
    }

    onPointerEnd(event) {
      if (event.pointerId !== this.activePointer) return;
      if (this.activated && this.colorReady && this.pendingPoint) {
        this.paintAt(this.pendingPoint.clientX, this.pendingPoint.clientY);
      }
      this.activePointer = null;
      this.pointerStart = null;
      this.pendingPoint = null;
      this.lastPoint = null;
      this.setMarkerVisible(false, event);
    }

    onPointerLeave(event) {
      if (event.pointerType === 'mouse') {
        this.mouseInside = false;
        this.lastPoint = null;
      }
      this.setMarkerVisible(false, event);
    }

    onClickCapture(event) {
      this.setMarkerVisible(false, event);
      if (performance.now() >= this.suppressClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.suppressClickUntil = 0;
    }

    onScroll() {
      this.lastPoint = null;
      this.setMarkerVisible(false);
    }

    destroy() {
      this.setMarkerVisible(false);
      if (this.renderFrame) cancelAnimationFrame(this.renderFrame);
      if (this.activationTimer) clearTimeout(this.activationTimer);
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.frame.removeEventListener('pointerenter', this.onPointerEnter);
      this.frame.removeEventListener('pointermove', this.onPointerMove);
      this.frame.removeEventListener('pointerdown', this.onPointerDown);
      this.frame.removeEventListener('pointerup', this.onPointerEnd);
      this.frame.removeEventListener('pointercancel', this.onPointerEnd);
      this.frame.removeEventListener('pointerleave', this.onPointerLeave);
      this.link?.removeEventListener('click', this.onClickCapture, true);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.resize);
    }
  }

  const storyReveals = [...document.querySelectorAll('[data-story-reveal]')].map(
    (frame) => new StorySceneReveal(frame),
  );

  const productDesignReveals = [];
  const designRevealPairsReady = Promise.resolve(
    window.DVIY_DESIGN_REVEAL_PAIRS_READY || window.DVIY_DESIGN_REVEAL_PAIRS || {},
  ).then(
    (designRevealPairs) => {
      const initializedFrames = new Set();
      document.querySelectorAll('[data-product-open][data-product-id]').forEach((link) => {
        const productId = link.dataset.productId;
        const pair = designRevealPairs[productId];
        const frame = link.querySelector('.product-card__blanket, .design-tile__image');
        if (!pair || !frame || initializedFrames.has(frame)) return;
        initializedFrames.add(frame);
        productDesignReveals.push(new ProductDesignReveal(frame, pair, productId));
      });
      return productDesignReveals;
    },
  );
  window.DVIY_DESIGN_REVEALS_READY = designRevealPairsReady;

  window.addEventListener(
    'pagehide',
    () => [...productDesignReveals, ...storyReveals].forEach((reveal) => reveal.destroy()),
    { once: true },
  );

  const storageKey = 'dviy-storyboard-saved-v4';
  const savedButtons = [...document.querySelectorAll('[data-save-product]')];
  const savedOpenButton = document.querySelector('[data-saved-open]');
  const savedCount = document.querySelector('[data-saved-count]');
  const dialog = document.querySelector('[data-saved-dialog]');
  const closeButton = dialog?.querySelector('[data-saved-close]');
  const savedItems = dialog?.querySelector('[data-saved-items]');
  const savedStatus = dialog?.querySelector('[data-saved-status]');
  const products = new Map();
  const v6DesignRecords = new Map();
  const v6DesignIdentity = product => {
    const record = v6DesignRecords.get(product.id);
    const handle = new URL(product.url, location.href).pathname.split('/').filter(Boolean).pop();
    return {
      designCode: product.designCode || record?.designCode || '',
      handle,
      // Only join a numeric record ID when it belongs to this exact product.
      id: record?.handle === handle ? String(record.id) : '',
      title: product.shortTitle,
    };
  };
  const syncV6PurchaseContext = (product, variant) => {
    const form = document.querySelector('[data-v6-cart-intent]');
    if (!form || !product || !variant) return null;
    const identity = v6DesignIdentity(product);
    const values = {
      id: String(variant.id), quantity: '1',
      'properties[_Design ID]': identity.designCode,
      'properties[_Design Source]': identity.handle,
      'properties[_Origin Page]': location.pathname,
      'properties[_Selection Mode]': 'legacy',
    };
    for (const input of form.elements) if (Object.hasOwn(values, input.name)) input.value = values[input.name];
    return form;
  };
  let lastDialogTrigger = null;
  let productFinder = null;
  let productModal = null;
  let productSticky = null;
  let productRecommendations = null;
  let productRecentlyViewed = null;
  let productBrowseRecommendations = null;
  let productZoomFitter = null;
  let productStorefrontDetails = null;
  let productScenePaperFit = null;
  let productRailPagers = [];
  let prototypeCart = null;

  const readSaved = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
    } catch {
      return [];
    }
  };

  let saved = new Set(readSaved());

  // V8.2: hearts are also created after load (catalog grid, rails), so binding is a function.
  const bindSaveButton = (button) => {
    if (!button || button.dataset.saveBound === 'true') return;
    button.dataset.saveBound = 'true';
    products.set(button.dataset.productId, {
      id: button.dataset.productId,
      title: button.dataset.productTitle,
      price: button.dataset.productPrice,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
    });
    if (!savedButtons.includes(button)) savedButtons.push(button);
    button.hidden = false;
    button.addEventListener('click', () => toggleSaved(button));
  };
  savedButtons.forEach((button) => bindSaveButton(button));

  const announce = (message) => {
    if (savedStatus) savedStatus.textContent = message;
  };

  const persist = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...saved]));
    } catch {
      announce('Saved designs are available for this page visit, but could not be stored for later.');
    }
  };

  const updateButtons = () => {
    // V8.2: forget hearts whose tiles were re-rendered away (hidden registry buttons stay attached).
    for (let index = savedButtons.length - 1; index >= 0; index -= 1) {
      if (!savedButtons[index].isConnected) savedButtons.splice(index, 1);
    }
    savedButtons.forEach((button) => {
      const isSaved = saved.has(button.dataset.productId);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute(
        'aria-label',
        `${isSaved ? 'Remove' : 'Save'} ${button.dataset.productTitle}${isSaved ? ' from saved designs' : ''}`,
      );
    });
    if (savedCount) savedCount.textContent = String(saved.size);
    productModal?.updateSavedState();
  };

  const createSavedItem = (product) => {
    const item = document.createElement('article');
    item.className = 'saved-item';
    item.innerHTML = `
      <img src="${product.image}" alt="" width="76" height="76" loading="lazy">
      <div>
        <a href="${product.url}">${product.title}</a>
        <p>${product.price}</p>
      </div>
      <button type="button" data-remove-saved="${product.id}" aria-label="Remove ${product.title} from saved designs">Remove</button>
    `;
    return item;
  };

  const renderSaved = () => {
    if (!savedItems) return;
    savedItems.replaceChildren();
    const selectedProducts = [...saved].map((id) => products.get(id)).filter(Boolean);

    if (selectedProducts.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'saved-empty';
      empty.textContent = 'No saved designs yet. Use a heart on any featured blanket to keep it here.';
      savedItems.append(empty);
      announce('No saved designs.');
      return;
    }

    selectedProducts.forEach((product) => savedItems.append(createSavedItem(product)));
    announce(`${selectedProducts.length} saved design${selectedProducts.length === 1 ? '' : 's'}.`);
  };

  const toggleSaved = (button) => {
    const id = button.dataset.productId;
    const title = button.dataset.productTitle;
    if (saved.has(id)) {
      saved.delete(id);
      announce(`${title} removed from saved designs.`);
    } else {
      saved.add(id);
      announce(`${title} saved.`);
    }
    persist();
    updateButtons();
    renderSaved();
    productFinder?.refreshSaved();
  };

  if (savedOpenButton && dialog && closeButton) {
    savedOpenButton.hidden = false;
    savedOpenButton.addEventListener('click', () => {
      lastDialogTrigger = savedOpenButton;
      renderSaved();
      dialog.showModal();
      closeButton.focus();
    });
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => lastDialogTrigger?.focus());
  }

  savedItems?.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-remove-saved]');
    if (!removeButton) return;
    const product = products.get(removeButton.dataset.removeSaved);
    saved.delete(removeButton.dataset.removeSaved);
    persist();
    updateButtons();
    renderSaved();
    productFinder?.refreshSaved();
    announce(`${product?.title || 'Design'} removed from saved designs.`);
  });

  document.querySelectorAll('.product-rail').forEach((rail) => {
    const track = rail.querySelector('[data-product-track]');
    let drag = null;
    let touchDrag = null;
    let suppressClick = false;
    let offset = 0;

    const maxOffset = () => Math.max(0, track.scrollWidth - rail.clientWidth);
    const setOffset = (nextOffset) => {
      offset = Math.min(maxOffset(), Math.max(0, nextOffset));
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    };

    const snapOffset = () => {
      const firstCard = track.querySelector('.product-card');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (firstCard?.getBoundingClientRect().width || rail.clientWidth) + gap;
      setOffset(Math.round(offset / step) * step);
    };

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startOffset: offset,
        horizontal: false,
      };
    });

    rail.addEventListener('pointermove', (event) => {
      if (!drag || drag.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - drag.startX;
      const deltaY = event.clientY - drag.startY;

      if (!drag.horizontal && Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
        drag.horizontal = true;
        suppressClick = true;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      }

      if (drag.horizontal) setOffset(drag.startOffset - deltaX);
    });

    const finishDrag = (event) => {
      if (!drag || drag.pointerId !== event.pointerId) return;
      if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      rail.classList.remove('is-dragging');
      if (drag.horizontal) snapOffset();
      drag = null;
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    };

    rail.addEventListener('pointerup', finishDrag);
    rail.addEventListener('pointercancel', finishDrag);

    rail.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        const touch = event.touches[0];
        touchDrag = {
          startX: touch.clientX,
          startY: touch.clientY,
          startOffset: offset,
          horizontal: false,
        };
      },
      { passive: true },
    );

    rail.addEventListener(
      'touchmove',
      (event) => {
        if (!touchDrag || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const deltaX = touch.clientX - touchDrag.startX;
        const deltaY = touch.clientY - touchDrag.startY;

        if (!touchDrag.horizontal && Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
          touchDrag.horizontal = true;
          suppressClick = true;
          rail.classList.add('is-dragging');
        }

        if (touchDrag.horizontal) setOffset(touchDrag.startOffset - deltaX);
      },
      { passive: true },
    );

    const finishTouchDrag = () => {
      if (!touchDrag) return;
      rail.classList.remove('is-dragging');
      if (touchDrag.horizontal) snapOffset();
      touchDrag = null;
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    };

    rail.addEventListener('touchend', finishTouchDrag, { passive: true });
    rail.addEventListener('touchcancel', finishTouchDrag, { passive: true });
    rail.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true,
    );

    rail.addEventListener('focusin', (event) => {
      const card = event.target.closest('.product-card');
      if (!card) return;
      const railRect = rail.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      if (cardRect.left < railRect.left) setOffset(offset - (railRect.left - cardRect.left));
      if (cardRect.right > railRect.right) setOffset(offset + (cardRect.right - railRect.right));
    });

    window.addEventListener('resize', () => setOffset(offset));
  });

  let productCatalogPromise = null;
  const loadProductCatalog = () => {
    if (productCatalogPromise) return productCatalogPromise;
    productCatalogPromise = fetch(window.DVIY_PRODUCT_CATALOG_URL || 'product-catalog.json')
      .then((response) => {
        if (!response.ok) throw new Error(`Product catalog returned ${response.status}.`);
        return response.json();
      })
      .then((catalog) => {
        if (!Array.isArray(catalog)) throw new Error('Product catalog must be an array.');
        return new Map(catalog.map((product) => [product.id, product]));
      });
    return productCatalogPromise;
  };

  // V8.2: the "All designs" grid, search and category tiles run on the full design catalog
  // (design-catalog.json, 24 per page). The 16 static cards in the HTML are the no-JavaScript
  // fallback and are replaced as soon as the catalog index is ready. Thumbnail coloring is
  // re-attached to any of the 8 paired local designs when they appear on the current page.
  // V5 (2026-09-04, Gus): V3's category pills. `config` is V3's CATEGORY_CONFIG (label, query,
  // pid); `overrides` is V3's pill_overrides string ("p1:CODE,..."). A category pill is kept only
  // when the catalog index knows that category; its image is the override design's image, else
  // the category's first design; "All designs" uses its override image, else the 8.3 tile.
  const buildV5Pills = (pills, index) => {
    const overrides = new Map();
    String(pills.overrides || '')
      .split(',')
      .map((pair) => pair.split(':'))
      .forEach(([pid, code]) => {
        if (pid && code) overrides.set(recsApi.normalize(pid), recsApi.normalize(code));
      });
    const overrideImage = (pid) => {
      const code = overrides.get(recsApi.normalize(pid));
      const entry = code && index && index.byCode ? index.byCode.get(code) : null;
      return entry && entry.record && entry.record.image ? entry.record.image : '';
    };
    const categories = new Map((index && index.categories ? index.categories : []).map((category) => [category.key, category]));
    const tiles = [];
    pills.config.forEach((item) => {
      if (item.kind === 'favorites') {
        tiles.push({ key: 'saved', label: item.label, heart: true });
        return;
      }
      if (!item.query) {
        tiles.push({ key: 'all', label: item.label, image: overrideImage(item.pid) || window.DVIY_EXPERIMENTAL_V8_ALL_TILE_URL || 'assets/design-reveals/dog-with-flowers-base.webp' });
        return;
      }
      if (item.collectionTheme) {
        const entry = index.byCode.get(recsApi.normalize(item.code));
        tiles.push({ key: 'theme:' + item.collectionTheme, label: item.label, image: overrideImage(item.pid) || entry?.record?.image || '' });
        return;
      }
      const category = categories.get(`category:${recsApi.normalize(item.query)}`);
      tiles.push({ key: `category:${recsApi.normalize(item.query)}`, label: item.label, image: overrideImage(item.pid) || category?.image || '' });
    });
    return tiles;
  };

  class CollectionProductFinder {
    constructor(root, designCatalogLoader) {
      this.root = root;
      this.designCatalogLoader = designCatalogLoader;
      this.form = root?.querySelector('[data-product-search]');
      this.input = root?.querySelector('[data-product-search-input]');
      this.clearButton = root?.querySelector('[data-product-search-clear]');
      this.categoryRail = root?.querySelector('[data-category-rail]');
      const themeNavigation = root?.querySelector('[data-v6-theme-navigation]');
      const themePrevious = root?.querySelector('[data-v6-theme-previous]');
      const themeNext = root?.querySelector('[data-v6-theme-next]');
      const themeHint = root?.querySelector('[data-v6-theme-hint]');
      const updateThemeNavigation = () => {
        if (!this.categoryRail || !themeNavigation) return;
        const max = Math.max(0, this.categoryRail.scrollWidth - this.categoryRail.clientWidth);
        const atStart = this.categoryRail.scrollLeft <= 2;
        const atEnd = this.categoryRail.scrollLeft >= max - 2;
        themeNavigation.hidden = max <= 2;
        if (themePrevious) themePrevious.disabled = atStart;
        if (themeNext) themeNext.disabled = atEnd;
        if (themeHint) themeHint.textContent = atEnd ? 'Back to earlier themes' : 'Swipe for more themes';
      };
      const scrollThemes = direction => {
        if (!this.categoryRail) return;
        this.categoryRail.scrollBy({
          left: direction * Math.max(93, this.categoryRail.clientWidth - 93),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };
      themePrevious?.addEventListener('click', () => scrollThemes(-1));
      themeNext?.addEventListener('click', () => scrollThemes(1));
      this.categoryRail?.addEventListener('scroll', updateThemeNavigation, { passive: true });
      if (this.categoryRail && 'ResizeObserver' in window) new ResizeObserver(updateThemeNavigation).observe(this.categoryRail);
      window.addEventListener('resize', updateThemeNavigation, { passive: true });
      updateThemeNavigation();
      this.grid = root?.querySelector('[data-product-grid]');
      this.count = root?.querySelector('[data-product-results-count]');
      this.headerCount = root?.querySelector('[data-catalog-count]');
      this.empty = root?.querySelector('[data-product-results-empty]');
      this.pagination = root?.querySelector('[data-product-pagination]');
      this.previous = root?.querySelector('[data-product-page-previous]');
      this.next = root?.querySelector('[data-product-page-next]');
      this.pageStatus = root?.querySelector('[data-product-page-status]');
      this.resultsHeading = root?.querySelector('#all-designs-heading');
      this.activeFilter = 'all';
      this.themeMembers = new Map();
      this.themeRequest = null;
      this.themeRevision = 0;
      this.themeStatus = root?.querySelector('[data-v6-theme-status]');
      this.page = 0;
      this.pageSize = 24;
      this.index = null;
      this.dynamicReveals = [];
      this.staticRevealsCleared = false;

      if (!this.root || !this.form || !this.input || !this.grid || typeof this.designCatalogLoader !== 'function') return;
      this.bind();
      this.designCatalogLoader()
        .then((index) => {
          this.index = index;
          if (this.headerCount) this.headerCount.textContent = `${index.availableCount.toLocaleString('en-US')} designs`;
          this.renderCategories();
          this.render();
        })
        .catch((error) => console.error('The design catalog could not be loaded; the 16 featured designs remain.', error));
    }

    bind() {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.input.value = this.input.value.trim();
        this.page = 0;
        this.render();
      });
      this.input.addEventListener('input', () => {
        this.page = 0;
        this.render();
      });
      this.input.addEventListener('search', () => {
        this.page = 0;
        this.render();
      });
      this.clearButton?.addEventListener('click', () => {
        this.input.value = '';
        this.page = 0;
        this.render();
        this.input.focus();
      });
      // Delegated so the generated category tiles and the shelves' "See all" buttons all work.
      this.root.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-product-filter]');
        if (filter) {
          const key = filter.dataset.productFilter || 'all';
          if (key.startsWith('theme:')) {
            this.selectCollectionTheme(filter, key.slice(6));
            return;
          }
          this.cancelThemeRequest();
          this.activeFilter = key;
          this.page = 0;
          this.render();
          if (filter.hasAttribute('data-filter-scroll')) this.scrollToResults();
          return;
        }
        const reset = event.target.closest('[data-product-finder-reset]');
        if (reset) {
          this.cancelThemeRequest();
          this.activeFilter = 'all';
          this.input.value = '';
          this.page = 0;
          this.render();
          this.scrollToResults();
        }
      });
      this.previous?.addEventListener('click', () => {
        if (this.page === 0) return;
        this.page -= 1;
        this.render();
        this.scrollToResults();
      });
      this.next?.addEventListener('click', () => {
        this.page += 1;
        this.render();
        this.scrollToResults();
      });
    }

    cancelThemeRequest() {
      this.themeRevision += 1;
      this.themeRequest?.abort();
      this.themeRequest = null;
      this.grid?.removeAttribute('aria-busy');
      if (this.themeStatus) { this.themeStatus.textContent = ''; this.themeStatus.hidden = true; }
    }

    async selectCollectionTheme(button, theme) {
      this.cancelThemeRequest();
      const revision = this.themeRevision;
      const controller = new AbortController();
      this.themeRequest = controller;
      this.grid.setAttribute('aria-busy', 'true');
      if (this.themeStatus) { this.themeStatus.hidden = false; this.themeStatus.textContent = 'Loading ' + button.textContent.trim() + ' designs…'; }
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        if (!this.themeMembers.has(theme)) {
          const handles = new Set();
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(root + 'collections/blanket-coloring-kits-1', location.origin);
          url.searchParams.set('filter.p.m.custom.category', theme);
          url.searchParams.set('section_id', 'coloring-blanket-v6-theme-members');
          let pages = 1;
          for (let page = 1; page <= pages; page += 1) {
            url.searchParams.set('page', page);
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) throw new Error('Theme request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const node = html.querySelector('[data-v6-theme-members]');
            const data = node && JSON.parse(node.textContent);
            if (!data || data.theme !== theme || data.page !== page || !Array.isArray(data.handles) || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 8) throw new Error('Theme response did not match');
            pages = data.pages;
            data.handles.forEach(handle => handles.add(handle));
          }
          if (revision !== this.themeRevision) return;
          this.themeMembers.set(theme, handles);
        }
        if (revision !== this.themeRevision) return;
        this.activeFilter = 'theme:' + theme;
        this.page = 0;
        this.render();
        if (this.themeStatus) this.themeStatus.hidden = true;
        this.scrollToResults();
      } catch (error) {
        if (revision !== this.themeRevision) return;
        if (this.themeStatus) {
          this.themeStatus.hidden = false;
          this.themeStatus.textContent = 'This theme could not load. Please try again or choose another category.';
        }
      } finally {
        clearTimeout(timeout);
        if (revision === this.themeRevision) {
          this.themeRequest = null;
          this.grid.removeAttribute('aria-busy');
        }
      }
    }

    scrollToResults() {
      window.requestAnimationFrame(() => {
        this.resultsHeading?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    }

    renderCategories() {
      if (!this.categoryRail || !this.index) return;
      // V5 (2026-09-04, Gus): the pills are V3's list (labels, order) with V3's pill images
      // (window.DVIY_V6_PILLS, set by the section from its settings); the 8.3 list is the fallback.
      const tiles = window.DVIY_V6_PILLS && Array.isArray(window.DVIY_V6_PILLS.config)
        ? buildV5Pills(window.DVIY_V6_PILLS, this.index)
        : [
            { key: 'all', label: 'All designs', image: window.DVIY_EXPERIMENTAL_V8_ALL_TILE_URL || 'assets/design-reveals/dog-with-flowers-base.webp' },
            { key: 'saved', label: 'Saved', heart: true },
            ...(this.index.kidsCount ? [{ key: 'kids', label: 'Kids', image: this.index.kidsImage }] : []),
            ...this.index.categories.map((category) => ({ key: category.key, label: category.label, image: category.image })),
          ];
      this.categoryRail.replaceChildren(
        ...tiles.map((tile) => {
          const button = document.createElement('button');
          button.className = `design-category${tile.heart ? ' design-category--saved' : ''}`;
          button.type = 'button';
          button.dataset.productFilter = tile.key;
          button.dataset.filterScroll = '';
          button.setAttribute('aria-pressed', String(tile.key === this.activeFilter));
          const frame = document.createElement('span');
          frame.className = 'design-category__image';
          if (tile.heart) {
            frame.setAttribute('aria-hidden', 'true');
            frame.innerHTML = "<svg viewBox=\"0 0 16 16\" aria-hidden=\"true\"><path d=\"m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15\"/></svg>";
          } else {
            const image = document.createElement('img');
            image.src = withCdnWidth(tile.image, 320);
            image.alt = '';
            image.width = 180;
            image.height = 180;
            image.loading = 'lazy';
            image.decoding = 'async';
            frame.append(image);
          }
          const label = document.createElement('span');
          label.textContent = tile.label;
          button.append(frame, label);
          return button;
        }),
      );
    }

    render() {
      if (!this.index) return;
      const query = this.input.value;
      const members = this.activeFilter.startsWith('theme:') ? this.themeMembers.get(this.activeFilter.slice(6)) : null;
      const candidates = members ? this.index.entries.filter(entry => members.has(entry.record.handle)) : this.index.entries;
      const filtered = recsApi.filterEntries(candidates, members ? 'all' : this.activeFilter, query, saved);
      const pageCount = Math.max(1, Math.ceil(filtered.length / this.pageSize));
      this.page = Math.min(this.page, pageCount - 1);
      const start = this.page * this.pageSize;
      const slice = filtered.slice(start, start + this.pageSize);

      this.clearReveals();
      this.grid.replaceChildren(...slice.map((entry) => createGridCard(entry.product, entry.record)));
      this.attachReveals();
      updateButtons();

      this.root.querySelectorAll('.design-category[data-product-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.productFilter === this.activeFilter));
      });

      const activeCategory = Array.from(this.root.querySelectorAll('[data-product-filter]'))
        .find(button => button.dataset.productFilter === this.activeFilter);
      const categoryLabel = activeCategory?.matches('.design-category')
        ? activeCategory.textContent.trim()
        : activeCategory?.closest('.design-shelf')?.querySelector('h3')?.textContent.trim();
      const heading = this.resultsHeading?.querySelector('h3');
      if (heading) heading.textContent = categoryLabel || 'All designs';

      const hasFilters = Boolean(query.trim()) || this.activeFilter !== 'all';
      this.root.classList.toggle('is-filtering', hasFilters);
      if (this.clearButton) this.clearButton.hidden = !this.input.value;
      this.root.querySelectorAll('[data-product-finder-reset]').forEach((button) => {
        if (!button.closest('[data-product-results-empty]')) button.hidden = !hasFilters;
      });

      if (this.count) {
        this.count.textContent = filtered.length
          ? `${filtered.length.toLocaleString('en-US')} design${filtered.length === 1 ? '' : 's'}`
          : 'No matching designs';
      }
      this.grid.hidden = filtered.length === 0;
      if (this.empty) this.empty.hidden = filtered.length !== 0;
      if (this.pagination) this.pagination.hidden = filtered.length <= this.pageSize;
      if (this.previous) this.previous.disabled = this.page === 0;
      if (this.next) this.next.disabled = this.page >= pageCount - 1;
      if (this.pageStatus) this.pageStatus.textContent = `Page ${this.page + 1} of ${pageCount}`;
    }

    clearReveals() {
      if (!this.staticRevealsCleared) {
        this.staticRevealsCleared = true;
        for (let index = productDesignReveals.length - 1; index >= 0; index -= 1) {
          const reveal = productDesignReveals[index];
          if (reveal.card && this.grid.contains(reveal.card)) {
            reveal.destroy();
            productDesignReveals.splice(index, 1);
          }
        }
      }
      this.dynamicReveals.forEach((reveal) => reveal.destroy());
      this.dynamicReveals = [];
    }

    attachReveals() {
      const pairs = window.DVIY_DESIGN_REVEAL_PAIRS || {};
      if (!pairs || typeof pairs !== 'object') return;
      this.grid.querySelectorAll('[data-product-open][data-product-id]').forEach((link) => {
        const pair = pairs[link.dataset.productId];
        const frame = link.querySelector('.product-card__blanket');
        if (!pair || !frame) return;
        this.dynamicReveals.push(new ProductDesignReveal(frame, pair, link.dataset.productId));
      });
    }

    refreshSaved() {
      if (this.activeFilter === 'saved') this.render();
    }
  }

  // V8.2: the popup gallery shows up to eight photos (live product data can carry more than five).
  const GALLERY_LIMIT = 8;

  class CollectionProductModal {
    constructor(modal, catalogLoader) {
      this.modal = modal;
      this.catalogLoader = catalogLoader;
      this.catalog = new Map();
      this.sheet = modal?.querySelector('.product-modal__sheet');
      this.closeButton = modal?.querySelector('[data-product-modal-close]');
      this.backButton = modal?.querySelector('[data-product-modal-back]');
      this.mainImage = modal?.querySelector('[data-product-modal-image]');
      this.zoomTrigger = modal?.querySelector('[data-product-modal-zoom-open]');
      this.imageFallback = modal?.querySelector('[data-product-modal-image-fallback]');
      this.thumbnails = modal?.querySelector('[data-product-modal-thumbnails]');
      this.title = modal?.querySelector('[data-product-modal-title]');
      this.design = modal?.querySelector('[data-product-modal-design]');
      this.price = modal?.querySelector('[data-product-modal-price]');
      this.comparePrice = modal?.querySelector('[data-product-modal-compare-price]');
      this.sizes = modal?.querySelector('[data-product-modal-sizes]');
      this.primary = modal?.querySelector('[data-product-modal-primary]');
      this.productLink = modal?.querySelector('[data-product-modal-product-link]');
      this.saveButton = modal?.querySelector('[data-product-modal-save]');
      this.status = modal?.querySelector('[data-product-modal-status]');
      this.zoomDialog = document.querySelector('[data-product-image-zoom]');
      this.zoomImage = this.zoomDialog?.querySelector('[data-product-image-zoom-image]');
      this.zoomImageFallback = this.zoomDialog?.querySelector('[data-product-image-zoom-fallback]');
      this.zoomTitle = this.zoomDialog?.querySelector('[data-product-image-zoom-title]');
      this.zoomCaption = this.zoomDialog?.querySelector('[data-product-image-zoom-caption]');
      this.zoomCloseButton = this.zoomDialog?.querySelector('[data-product-image-zoom-close]');
      this.currentProduct = null;
      this.currentVariant = null;
      this.currentImageIndex = 0;
      this.opener = null;
      this.zoomOpener = null;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: 'USD',
      });

      if (!this.modal || typeof this.catalogLoader !== 'function') return;
      this.bind();
    }

    async ensureCatalog() {
      if (this.catalog.size) return this.catalog;
      this.catalog = await this.catalogLoader();
      return this.catalog;
    }

    withWidth(value, width) {
      if (!value) return '';
      try {
        const url = new URL(value);
        if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', String(width));
        return url.toString();
      } catch {
        return value;
      }
    }

    formatMoney(cents) {
      return this.money.format(Number(cents || 0) / 100);
    }

    bind() {
      document.addEventListener('click', async (event) => {
        const link = event.target.closest('[data-product-open]');
        if (!link || event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        let product = null;
        try {
          product = (await this.ensureCatalog()).get(link.dataset.productId);
        } catch (error) {
          console.error('Product details could not be loaded; opening the product page instead.', error);
        }
        if (!product) {
          window.location.assign(link.href);
          return;
        }
        this.open(product, link);
      });

      this.closeButton?.addEventListener('click', () => this.modal.close());
      this.backButton?.addEventListener('click', () => this.modal.close());
      this.zoomTrigger?.addEventListener('click', () => this.openImageZoom());
      this.zoomCloseButton?.addEventListener('click', () => this.zoomDialog.close());
      this.zoomDialog?.addEventListener('click', (event) => {
        if (event.target === this.zoomDialog) this.zoomDialog.close();
      });
      this.zoomDialog?.addEventListener('close', () => {
        document.body.classList.remove('product-image-zoom-open');
        const target = this.zoomOpener;
        this.zoomOpener = null;
        if (this.modal.open) target?.focus();
      });
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) this.modal.close();
      });
      this.modal.addEventListener('close', () => {
        if (this.zoomDialog?.open) {
          this.zoomOpener = null;
          this.zoomDialog.close();
        }
        document.body.classList.remove('product-modal-open');
        this.opener?.focus();
      });

      this.thumbnails?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-product-modal-thumbnail]');
        if (button) this.selectImage(Number(button.dataset.productModalThumbnail));
      });

      this.sizes?.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input?.checked) return;
        const variant = this.currentProduct?.variants.find((item) => String(item.id) === input.value);
        if (variant) this.selectVariant(variant, { announce: true });
      });

      this.saveButton?.addEventListener('click', () => {
        if (!this.currentProduct) return;
        const cardButton = document.querySelector(
          `[data-save-product][data-product-id="${CSS.escape(this.currentProduct.id)}"]`,
        );
        if (!cardButton) return;
        toggleSaved(cardButton);
        if (this.status) {
          this.status.textContent = saved.has(this.currentProduct.id)
            ? `${this.currentProduct.shortTitle} saved.`
            : `${this.currentProduct.shortTitle} removed from saved designs.`;
        }
      });

      this.mainImage?.addEventListener('load', () => {
        this.mainImage.hidden = false;
        if (this.zoomTrigger) this.zoomTrigger.hidden = false;
        if (this.imageFallback) this.imageFallback.hidden = true;
      });
      this.mainImage?.addEventListener('error', () => {
        this.mainImage.hidden = true;
        if (this.zoomTrigger) this.zoomTrigger.hidden = true;
        if (this.imageFallback) this.imageFallback.hidden = false;
      });
      this.zoomImage?.addEventListener('load', () => {
        this.zoomImage.hidden = false;
        if (this.zoomImageFallback) this.zoomImageFallback.hidden = true;
      });
      this.zoomImage?.addEventListener('error', () => {
        this.zoomImage.hidden = true;
        if (this.zoomImageFallback) this.zoomImageFallback.hidden = false;
      });
    }

    open(product, opener) {
      this.currentProduct = product;
      this.currentVariant = product.variants.find((variant) => variant.available) || product.variants[0];
      // V8.1 recommendations: a rail tile inside the modal keeps the original opener for focus return.
      this.opener = this.modal.contains(opener) && this.opener ? this.opener : opener;
      this.modal.dataset.productId = product.id;
      if (this.saveButton) this.saveButton.dataset.designCode = v6DesignIdentity(product).designCode;
      this.renderProduct();
      if (!this.modal.open) this.modal.showModal();
      document.body.classList.add('product-modal-open');
      this.sheet.scrollTop = 0;
      this.closeButton?.focus();
      productSticky?.select(product, this.currentVariant);
      // V8.1 recommendations: announce the opened product so the rail can follow it.
      document.dispatchEvent(new CustomEvent('coloring:design-change', { bubbles: true, detail: { design: v6DesignIdentity(product) } }));
      document.dispatchEvent(new CustomEvent('dviy:product-modal-open', { detail: { product, opener } }));
    }

    renderProduct() {
      const product = this.currentProduct;
      if (!product) return;
      this.title.textContent = `Coloring Blanket Kit — ${product.shortTitle}`;
      this.design.textContent = product.shortTitle;
      this.renderThumbnails();
      this.renderSizes();
      this.selectImage(0);
      this.selectVariant(this.currentVariant, { announce: false });
      this.updateSavedState();
      if (this.status) this.status.textContent = '';
    }

    renderThumbnails() {
      this.thumbnails.replaceChildren();
      this.currentProduct.images.slice(0, GALLERY_LIMIT).forEach((source, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-modal__thumbnail';
        button.dataset.productModalThumbnail = String(index);
        button.setAttribute('aria-label', `View ${this.currentProduct.shortTitle} product photo ${index + 1}`);
        button.setAttribute('aria-pressed', String(index === 0));
        const image = document.createElement('img');
        image.src = this.withWidth(source, 160);
        image.alt = '';
        image.width = 160;
        image.height = 160;
        image.loading = 'lazy';
        image.addEventListener('error', () => image.removeAttribute('src'), { once: true });
        button.append(image);
        this.thumbnails.append(button);
      });
    }

    selectImage(index) {
      const source = this.currentProduct?.images[index];
      if (!source || !this.mainImage) return;
      this.currentImageIndex = index;
      this.thumbnails.querySelectorAll('[data-product-modal-thumbnail]').forEach((button) => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.productModalThumbnail) === index));
      });
      this.mainImage.hidden = false;
      this.mainImage.dataset.productModalImageIndex = String(index);
      if (this.zoomTrigger) {
        this.zoomTrigger.hidden = false;
        this.zoomTrigger.setAttribute(
          'aria-label',
          `View larger image of ${this.currentProduct.shortTitle}, product photo ${index + 1}`,
        );
      }
      if (this.imageFallback) this.imageFallback.hidden = true;
      this.mainImage.alt = `${this.currentProduct.shortTitle} coloring blanket product photo ${index + 1}`;
      this.mainImage.src = this.withWidth(source, 900);
      if (this.zoomDialog?.open) this.updateZoomImage();
    }

    updateZoomImage() {
      const product = this.currentProduct;
      const source = product?.images[this.currentImageIndex];
      if (!product || !source || !this.zoomImage) return false;
      const position = `Product photo ${this.currentImageIndex + 1} of ${Math.min(product.images.length, GALLERY_LIMIT)}`;
      this.zoomImage.hidden = false;
      this.zoomImage.dataset.productModalImageIndex = String(this.currentImageIndex);
      this.zoomImage.alt = `Enlarged ${product.shortTitle} coloring blanket product photo ${this.currentImageIndex + 1}`;
      this.zoomImage.src = this.withWidth(source, 1800);
      if (this.zoomImageFallback) this.zoomImageFallback.hidden = true;
      if (this.zoomTitle) this.zoomTitle.textContent = `Enlarged ${product.shortTitle} product image`;
      if (this.zoomCaption) this.zoomCaption.textContent = `${product.shortTitle} — ${position}`;
      return true;
    }

    openImageZoom() {
      if (!this.zoomDialog || !this.updateZoomImage()) return;
      this.zoomOpener = this.zoomTrigger;
      if (!this.zoomDialog.open) this.zoomDialog.showModal();
      document.body.classList.add('product-image-zoom-open');
      this.zoomCloseButton?.focus();
    }

    renderSizes() {
      this.sizes.replaceChildren();
      this.currentProduct.variants.forEach((variant, index) => {
        const input = document.createElement('input');
        const id = `product-modal-size-${this.currentProduct.id}-${index}`;
        input.id = id;
        input.type = 'radio';
        input.name = 'product-modal-size';
        input.dataset.coloringOptionInput = '';
        input.dataset.optionPosition = '1';
        input.dataset.coloringOptionLabel = variant.size;
        input.value = String(variant.id);
        input.checked = String(variant.id) === String(this.currentVariant?.id);
        input.disabled = !variant.available;
        const label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = variant.size;
        this.sizes.append(input, label);
      });
    }

    selectVariant(variant, { announce }) {
      this.currentVariant = variant;
      syncV6PurchaseContext(this.currentProduct, variant);
      this.sizes.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === String(variant.id);
      });
      this.price.textContent = this.formatMoney(variant.price);
      this.comparePrice.textContent = this.formatMoney(variant.compareAt);
      this.comparePrice.hidden = !variant.compareAt || variant.compareAt <= variant.price;
      const destination = new URL(this.currentProduct.url);
      destination.searchParams.set('variant', String(variant.id));
      if (this.productLink) this.productLink.href = destination.toString();
      this.productLink?.setAttribute(
        'aria-label',
        `View ${this.currentProduct.shortTitle}, ${variant.size}, on the full product page`,
      );
      productSticky?.select(this.currentProduct, variant);
      if (announce && this.status) this.status.textContent = `${variant.size} selected. Price and product link updated.`;
    }

    // V8.2: re-render the gallery and sizes after live storefront data replaced the open
    // product's images and variants; keeps the viewed photo index and the chosen size when
    // they still exist.
    refreshRenderedProduct() {
      const product = this.currentProduct;
      if (!product || !this.modal.open) return;
      const photoCount = Math.min(product.images.length, GALLERY_LIMIT);
      const keepIndex = Math.min(this.currentImageIndex, Math.max(0, photoCount - 1));
      const current =
        product.variants.find((variant) => String(variant.id) === String(this.currentVariant?.id)) ||
        product.variants.find((variant) => variant.available) ||
        product.variants[0];
      this.currentVariant = current;
      this.renderThumbnails();
      this.renderSizes();
      this.selectImage(keepIndex);
      if (current) this.selectVariant(current, { announce: false });
    }

    updateSavedState() {
      if (!this.saveButton || !this.currentProduct) return;
      const isSaved = saved.has(this.currentProduct.id);
      this.saveButton.setAttribute('aria-pressed', String(isSaved));
      this.saveButton.textContent = isSaved ? 'Remove from saved designs' : 'Save this design';
    }
  }

  class ProductStickyBar {
    constructor(root, catalogLoader) {
      this.root = root;
      this.catalogLoader = catalogLoader;
      this.image = root?.querySelector('[data-product-sticky-image]');
      this.title = root?.querySelector('[data-product-sticky-title]');
      this.size = root?.querySelector('[data-product-sticky-size]');
      this.price = root?.querySelector('[data-product-sticky-price]');
      this.addButton = root?.querySelector('[data-prototype-add]');
      this.currentProduct = null;
      this.currentVariant = null;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: 'USD',
      });

      if (!this.root || typeof this.catalogLoader !== 'function') return;
      this.root.hidden = false;
      if (this.addButton) this.addButton.disabled = true;
      this.updateVisibility = this.updateVisibility.bind(this);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      window.addEventListener('resize', this.updateVisibility, { passive: true });
      this.updateVisibility();
      this.catalogLoader()
        .then((catalog) => {
          const firstProduct = catalog.values().next().value;
          if (!firstProduct) return;
          const firstVariant = firstProduct.variants.find((variant) => variant.available) || firstProduct.variants[0];
          this.select(firstProduct, firstVariant);
        })
        .catch((error) => console.error('Floating product bar could not load its default product.', error));
    }

    formatMoney(cents) {
      return this.money.format(Number(cents || 0) / 100);
    }

    updateVisibility() {
      const scene = document.querySelector('.story-scene--alpine');
      if (!scene || !this.root) return;
      const show = window.scrollY + window.innerHeight >= scene.offsetTop + Math.min(260, window.innerHeight * 0.35);
      this.root.classList.toggle('is-visible', show);
      this.root.setAttribute('aria-hidden', String(!show));
    }

    select(product, variant) {
      if (!product || !variant || !this.root) return;
      this.currentProduct = product;
      this.currentVariant = variant;
      if (this.title) this.title.textContent = product.shortTitle;
      if (this.size) this.size.textContent = variant.size;
      if (this.price) this.price.textContent = this.formatMoney(variant.price);
      const cardImage = document.querySelector(
        `[data-save-product][data-product-id="${CSS.escape(product.id)}"]`,
      )?.dataset.productImage;
      if (this.image) {
        this.image.src = cardImage || product.images[0] || '';
        this.image.alt = '';
      }
      if (this.addButton) this.addButton.disabled = !variant.available;
    }
  }

  // ===================================================================================
  // V8.1 RECOMMENDATIONS — START (2026-09-01, updated for V8.2). "You may also like" rail
  // inside the product modal, fed by the recommendation API for the opened design. In 8.2 the
  // tiles carry hearts (shared factory below) and every render is announced through
  // `dviy:recommendations-rendered` so the browse-page rail can mirror it without a second
  // request. Failure policy: every entry point catches its own errors and only ever hides
  // the rail; the modal never waits on this class.
  // ===================================================================================
  class ProductModalRecommendations {
    constructor(modal, catalogLoader, moduleApi, configSource) {
      this.modal = modal;
      this.catalogLoader = catalogLoader;
      this.api = moduleApi || null;
      this.mount = modal?.querySelector('[data-product-modal-recommendations]');
      this.rail = modal?.querySelector('[data-product-modal-recommendations-rail]');
      this.registry = modal?.querySelector('[data-recommendation-registry]');
      this.token = 0;
      if (!this.modal || !this.mount || !this.rail || !this.api || typeof this.catalogLoader !== 'function') {
        if (this.mount) this.mount.hidden = true;
        return;
      }
      this.config = this.api.readConfig(configSource);
      this.client = this.api.createClient(this.config, (url, init) => window.fetch(url, init));
      document.addEventListener('dviy:product-modal-open', (event) => {
        try {
          this.refresh(event.detail && event.detail.product).catch((error) => this.fail(error));
        } catch (error) {
          this.fail(error);
        }
      });
      this.modal.addEventListener('close', () => {
        try {
          this.token += 1;
          this.client.cancel();
          this.clear();
        } catch (error) {
          this.fail(error);
        }
      });
    }

    clear() {
      this.rail.replaceChildren();
      this.mount.hidden = true;
    }

    debug(message) {
      try {
        console.debug('[version-8-2] recommendations', message);
      } catch (_error) {
        /* logging must never matter */
      }
    }

    fail(error) {
      console.error('Recommendations failed; the rail is hidden.', error);
      try {
        this.clear();
      } catch (_error) {
        /* nothing else to do */
      }
    }

    announce(product, items) {
      document.dispatchEvent(new CustomEvent('dviy:recommendations-rendered', { detail: { product, items } }));
    }

    async refresh(product) {
      this.token += 1;
      const token = this.token;
      this.clear();
      const code = String(product && product.designCode ? product.designCode : '').trim();
      const catalog = await this.catalogLoader();
      if (token !== this.token) return;
      const result = await this.client.load(code);
      if (token !== this.token || result.status === 'stale') return;
      const localProducts = [...catalog.values()].filter((item) => !item.recommendationOnly);
      let items;
      if (result.status === 'api') {
        const localByCode = this.api.indexByDesignCode(localProducts);
        items = result.records.map((record) => {
          const item = this.api.adaptRecord(record, localByCode);
          if (item.recommendationOnly) this.register(item, record, catalog);
          return { product: item, record };
        });
      } else {
        this.debug(`fallback: ${result.reason}`);
        if (product?.standaloneRecommendationSource) {
          this.clear();
          this.announce(product, []);
          return;
        }
        items = this.api
          .localFallback(product, localProducts, this.readCategories(), this.config.limit)
          .map((item) => ({ product: item, record: null }));
      }
      if (token !== this.token) return;
      if (!items.length) {
        this.clear();
        this.announce(product, []);
        return;
      }
      this.rail.replaceChildren(...items.map((item) => createDesignTile(item.product, item.record, { marker: 'recommendationTile' })));
      updateButtons();
      this.rail.scrollLeft = 0;
      this.mount.hidden = false;
      this.announce(product, items);
    }

    readCategories() {
      const map = new Map();
      document.querySelectorAll('[data-product-card]').forEach((card) => {
        const list = String(card.dataset.productCategories || '').split(/\s+/).filter(Boolean);
        map.set(card.dataset.productCard, new Set(list));
      });
      return map;
    }

    // Designs outside the catalog Map join it (so the [data-product-open] handler can open
    // them) and get a hidden save button that survives rail re-renders, so the modal's own
    // Save button always finds an anchor for the open product.
    register(product, record, catalog) {
      if (!catalog.has(product.id)) catalog.set(product.id, product);
      if (!this.registry || this.registry.querySelector(`[data-product-id="${CSS.escape(product.id)}"]`)) return;
      const button = createSaveButton(product, record);
      button.hidden = true;
      button.dataset.registry = 'true';
      this.registry.append(button);
    }
  }
  // V8.1 RECOMMENDATIONS — END


  // ===================================================================================
  // V8.2 CATALOG, RAILS AND HEARTS — START (2026-09-01). Full-catalog browse support, the
  // browse-page "You may also like" and "Recently viewed" rails, and hearts on every dynamic
  // tile. Pure logic (index, filters, adaptation) lives in recommendations.js. Depends on the
  // saved-designs closure above (products, saved, savedButtons, bindSaveButton, updateButtons).
  // ===================================================================================
  const recsApi = window.DVIY_RECOMMENDATIONS_MODULE || null;
  const HEART_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 5.8a5.4 5.4 0 0 0-7.7 0L12 6.9l-1.1-1.1a5.4 5.4 0 0 0-7.7 7.7L12 22l8.8-8.5a5.4 5.4 0 0 0 0-7.7Z"></path></svg>';
  const moneyFormat = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const withCdnWidth = (value, width) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', String(width));
      return url.toString();
    } catch {
      return value;
    }
  };
  const staticTileImage = (product) => {
    const button = document.querySelector(`[data-save-product][data-product-id="${CSS.escape(product.id)}"]`);
    return (button && button.dataset.productImage) || (product.images && product.images[0]) || '';
  };
  const tileImageFor = (product, record) => (record ? record.image : product.lineArt || staticTileImage(product));
  const fromPrice = (product) => {
    const cents = recsApi ? recsApi.lowestAvailablePrice(product.variants) : null;
    return cents === null ? '' : moneyFormat.format(cents / 100);
  };
  // V5 (2026-09-04, Gus): cards and tiles show the crossed-out compare-at price of the same variant
  // that sets the "From" price, like the live collection grid.
  const fromPricing = (product) => {
    const cents = recsApi ? recsApi.lowestAvailablePrice(product.variants) : null;
    if (cents === null) return null;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variant =
      variants.find((candidate) => candidate && candidate.available === true && candidate.price === cents) ||
      variants.find((candidate) => candidate && candidate.price === cents) ||
      null;
    const raw = variant ? variant.compareAt ?? variant.compareAtPrice ?? null : null;
    const compareAt = Number.isInteger(raw) && raw > cents ? raw : null;
    return { price: moneyFormat.format(cents / 100), compareAt: compareAt === null ? '' : moneyFormat.format(compareAt / 100) };
  };
  const renderPricing = (element, product, prefix) => {
    const pricing = fromPricing(product);
    element.replaceChildren();
    if (!pricing) return;
    if (pricing.compareAt) {
      const was = document.createElement('s');
      was.textContent = pricing.compareAt;
      element.append(was, ' ');
    }
    element.append(`${prefix}${pricing.price}`);
  };
  const drawerInfo = (product, record) => {
    const price = fromPrice(product);
    return {
      id: product.id,
      title: product.shortTitle,
      price: price ? `From ${price}` : '',
      url: product.url,
      image: tileImageFor(product, record),
    };
  };
  const serializeProduct = (product) => ({
    id: product.id,
    designCode: product.designCode || '',
    shortTitle: product.shortTitle,
    title: product.title,
    url: product.url,
    images: [...(product.images || [])].slice(0, GALLERY_LIMIT),
    lineArt: product.lineArt || staticTileImage(product),
    variants: (product.variants || []).map((variant) => ({
      id: String(variant.id),
      size: variant.size,
      price: variant.price,
      compareAt: variant.compareAt ?? null,
      available: Boolean(variant.available),
    })),
    recommendationOnly: true,
  });

  // Every heart shares the static markup and the saved-designs closure.
  const createSaveButton = (product, record) => {
    const info = drawerInfo(product, record);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'save-button';
    button.dataset.saveProduct = '';
    button.dataset.productId = product.id;
    button.dataset.coloringFavorite = '';
    button.dataset.designCode = product.designCode || record?.designCode || '';
    button.dataset.productTitle = product.shortTitle;
    button.dataset.productPrice = info.price;
    button.dataset.productUrl = product.url;
    button.dataset.productImage = info.image;
    button.setAttribute('aria-label', `Save ${product.shortTitle}`);
    button.setAttribute('aria-pressed', String(saved.has(product.id)));
    button.innerHTML = HEART_SVG;
    bindSaveButton(button);
    return button;
  };

  // Shelf-style tile (rails): same anatomy as the curated shelves plus a heart.
  function createDesignTile(product, record, options = {}) {
    if (record) v6DesignRecords.set(product.id, record);
    const tile = document.createElement('article');
    tile.className = 'design-tile design-tile--dynamic';
    tile.dataset[options.marker || 'designTile'] = product.designCode || product.id;
    const link = document.createElement('a');
    link.className = 'design-tile__open';
    link.href = product.url;
    link.dataset.productOpen = '';
    link.dataset.productId = product.id;
    link.dataset.coloringDesignCard = '';
    link.dataset.designCode = product.designCode || record?.designCode || '';
    const frame = document.createElement('span');
    frame.className = 'design-tile__image';
    const image = document.createElement('img');
    image.src = withCdnWidth(tileImageFor(product, record), 480);
    image.alt = `${product.shortTitle} coloring blanket design`;
    image.width = 240;
    image.height = 240;
    image.loading = 'lazy';
    image.decoding = 'async';
    frame.append(image);
    const title = document.createElement('strong');
    title.textContent = product.shortTitle;
    const price = document.createElement('small');
    renderPricing(price, product, '');
    link.append(frame, title, price);
    tile.append(link);
    if (options.heart !== false) tile.append(createSaveButton(product, record));
    return tile;
  }

  // Grid card: same anatomy as the static "All designs" cards, built from a catalog entry.
  function createGridCard(product, record) {
    if (record) v6DesignRecords.set(product.id, record);
    const article = document.createElement('article');
    article.className = 'product-card';
    article.dataset.productCard = product.id;
    article.dataset.productCategories = recsApi ? recsApi.normalize(record.category) : '';
    const link = document.createElement('a');
    link.className = 'product-card__link';
    link.href = product.url;
    link.dataset.productOpen = '';
    link.dataset.productId = product.id;
    link.dataset.coloringDesignCard = '';
    link.dataset.designCode = product.designCode || record?.designCode || '';
    const imageWrap = document.createElement('span');
    imageWrap.className = 'product-card__image';
    const blanket = document.createElement('span');
    blanket.className = 'product-card__blanket';
    const image = document.createElement('img');
    image.className = 'product-card__design';
    image.src = withCdnWidth(record.image, 720);
    image.alt = `${product.shortTitle} coloring blanket design`;
    image.width = 960;
    image.height = 1200;
    image.loading = 'lazy';
    image.decoding = 'async';
    blanket.append(image);
    const tag = document.createElement('span');
    tag.className = 'product-card__tag';
    tag.textContent = record.category;
    imageWrap.append(blanket, tag);
    const copy = document.createElement('span');
    copy.className = 'product-card__copy';
    const heading = document.createElement('h3');
    heading.textContent = product.shortTitle;
    const size = document.createElement('span');
    const firstAvailable = (product.variants || []).find((variant) => variant.available) || (product.variants || [])[0];
    size.textContent = `${firstAvailable ? firstAvailable.size : ''} · 20 markers`;
    const price = document.createElement('strong');
    renderPricing(price, product, 'From ');
    copy.append(heading, size, price);
    link.append(imageWrap, copy);
    article.append(link, createSaveButton(product, record));
    return article;
  }

  // The full catalog: fetched once, indexed by the module, and every design registered into
  // the shared product Map (so any [data-product-open] link opens it) and into the Saved
  // drawer's product info (so saved designs from earlier visits still list).
  let designCatalogPromise = null;
  const loadDesignCatalog = () => {
    if (designCatalogPromise) return designCatalogPromise;
    designCatalogPromise = Promise.all([
      fetch(window.DVIY_DESIGN_CATALOG_URL || 'design-catalog.json').then((response) => {
        if (!response.ok) throw new Error(`Design catalog returned ${response.status}.`);
        return response.json();
      }),
      loadProductCatalog(),
    ]).then(([catalogJson, productCatalog]) => {
      if (!recsApi) throw new Error('The recommendations module is missing.');
      const index = recsApi.buildCatalogIndex(catalogJson, [...productCatalog.values()]);
      index.entries.forEach((entry) => {
        v6DesignRecords.set(entry.product.id, entry.record);
        if (!productCatalog.has(entry.product.id)) productCatalog.set(entry.product.id, entry.product);
        if (!products.has(entry.product.id)) products.set(entry.product.id, drawerInfo(entry.product, entry.record));
      });
      renderSaved();
      return index;
    });
    return designCatalogPromise;
  };

  // Browse-page "You may also like": mirrors whatever the modal rail rendered last, with a
  // "Similar to <design>" line, so no second API request is made.
  class BrowseRecommendationsRail {
    constructor(root) {
      this.mount = root?.querySelector('[data-browse-recommendations]');
      this.note = root?.querySelector('[data-browse-recommendations-note]');
      this.rail = root?.querySelector('[data-browse-recommendations-rail]');
      if (!this.mount || !this.rail) return;
      document.addEventListener('dviy:recommendations-rendered', (event) => {
        try {
          this.render(event.detail);
        } catch (error) {
          this.fail(error);
        }
      });
    }

    render(detail) {
      const product = detail && detail.product;
      const items = detail && Array.isArray(detail.items) ? detail.items : [];
      if (!product || !items.length) {
        this.rail.replaceChildren();
        this.mount.hidden = true;
        return;
      }
      if (this.note) this.note.textContent = `Similar to ${product.shortTitle}`;
      this.rail.replaceChildren(...items.map((item) => createDesignTile(item.product, item.record, { marker: 'recommendationTile' })));
      updateButtons();
      this.rail.scrollLeft = 0;
      this.mount.hidden = false;
    }

    fail(error) {
      console.error('Browse recommendations rail failed; it is hidden.', error);
      try {
        this.rail.replaceChildren();
        this.mount.hidden = true;
      } catch (_error) {
        /* nothing else to do */
      }
    }
  }

  // "Recently viewed": browser-local history of opened designs (newest first, unique, 20 kept,
  // 12 shown). Each entry stores the product itself so a design outside the catalog snapshot
  // still renders and opens after a reload.
  class RecentlyViewedRail {
    constructor(root, designCatalogLoader, productCatalogLoader) {
      this.mount = root?.querySelector('[data-recently-viewed]');
      this.rail = root?.querySelector('[data-recently-viewed-rail]');
      this.storageKey = 'dviy-storyboard-recently-viewed-v1';
      this.limit = 12;
      this.cap = 20;
      this.catalog = null;
      if (!this.mount || !this.rail || typeof productCatalogLoader !== 'function') return;
      document.addEventListener('dviy:product-modal-open', (event) => {
        try {
          this.record(event.detail && event.detail.product);
        } catch (error) {
          this.fail(error);
        }
      });
      Promise.all([productCatalogLoader(), typeof designCatalogLoader === 'function' ? designCatalogLoader().catch(() => null) : null])
        .then(([catalog]) => {
          this.catalog = catalog;
          this.render();
        })
        .catch((error) => this.fail(error));
    }

    read() {
      try {
        const parsed = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        return Array.isArray(parsed)
          ? parsed.filter((entry) => entry && typeof entry.id === 'string' && entry.product && typeof entry.product === 'object')
          : [];
      } catch {
        return [];
      }
    }

    write(entries) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(entries));
      } catch {
        /* storage may be blocked; the rail still works for this visit */
      }
    }

    record(product) {
      if (!product || !product.id) return;
      const entries = this.read().filter((entry) => entry.id !== product.id);
      entries.unshift({ id: product.id, product: serializeProduct(product), at: Date.now() });
      this.write(entries.slice(0, this.cap));
      this.render();
    }

    render() {
      if (!this.catalog) return;
      const tiles = [];
      for (const entry of this.read().slice(0, this.limit)) {
        let product = this.catalog.get(entry.id);
        if (!product) {
          product = entry.product;
          this.catalog.set(product.id, product);
        }
        tiles.push(createDesignTile(product, null, { marker: 'recentlyViewedTile' }));
      }
      this.rail.replaceChildren(...tiles);
      updateButtons();
      this.mount.hidden = tiles.length === 0;
    }

    fail(error) {
      console.error('Recently viewed rail failed; it is hidden.', error);
      try {
        this.rail.replaceChildren();
        this.mount.hidden = true;
      } catch (_error) {
        /* nothing else to do */
      }
    }
  }

  // V8.2 (2026-09-02): "View larger" fills the stage with the photo's real content. Product
  // photos carry wide white margins, so on a phone the blanket ended up small. The fitter
  // measures the non-white bounding box of each photo once (a CORS-enabled CDN copy drawn on a
  // small canvas), then scales and shifts the picture so that box fills the stage. The scale
  // is the largest that keeps the whole box inside the stage, so content is never cut; any
  // failure, a photo without white margins, or a gain under 3% leaves the plain fit.
  class ZoomImageFitter {
    constructor(dialog) {
      this.dialog = dialog;
      this.image = dialog?.querySelector('[data-product-image-zoom-image]');
      this.stage = this.image?.parentElement;
      this.cache = new Map();
      this.token = 0;
      if (!this.dialog || !this.image || !this.stage) return;
      this.image.addEventListener('load', () => this.fit());
      new MutationObserver(() => this.reset()).observe(this.image, { attributes: true, attributeFilter: ['src'] });
      this.dialog.addEventListener('close', () => this.reset());
      window.addEventListener(
        'resize',
        () => {
          if (this.dialog.open) this.fit();
        },
        { passive: true },
      );
    }

    reset() {
      this.token += 1;
      this.image.style.transform = '';
      delete this.image.dataset.zoomFit;
      delete this.image.dataset.zoomBox;
    }

    async fit() {
      this.token += 1;
      const token = this.token;
      const src = this.image.currentSrc || this.image.src;
      if (!src || !this.dialog.open) return;
      try {
        const box = await this.measure(src);
        if (token !== this.token) return;
        if (!box) {
          this.image.style.transform = '';
          return;
        }
        this.apply(box);
      } catch (_error) {
        if (token === this.token) this.image.style.transform = '';
      }
    }

    // A 400px CDN copy is enough to find the content box and keeps the probe small.
    probeUrl(src) {
      try {
        const url = new URL(src, window.location.href);
        if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '400');
        return url.toString();
      } catch {
        return src;
      }
    }

    measure(src) {
      if (this.cache.has(src)) return this.cache.get(src);
      const promise = new Promise((resolve, reject) => {
        const probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.decoding = 'async';
        probe.onload = () => {
          try {
            resolve(this.scan(probe));
          } catch (error) {
            reject(error);
          }
        };
        probe.onerror = () => reject(new Error('Zoom probe image failed to load.'));
        probe.src = this.probeUrl(src);
      }).catch(() => null);
      this.cache.set(src, promise);
      return promise;
    }

    scan(probe) {
      const size = 256;
      const ratio = probe.naturalWidth / probe.naturalHeight;
      const width = Math.max(1, Math.round(ratio >= 1 ? size : size * ratio));
      const height = Math.max(1, Math.round(ratio >= 1 ? size / ratio : size));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(probe, 0, 0, width, height);
      const { data } = context.getImageData(0, 0, width, height);
      let minX = width;
      let minY = height;
      let maxX = -1;
      let maxY = -1;
      for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
          const index = (y * width + x) * 4;
          if (data[index + 3] < 8) continue;
          if (data[index] < 242 || data[index + 1] < 242 || data[index + 2] < 242) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return null;
      const pad = 0.02;
      const x = Math.max(0, minX / width - pad);
      const y = Math.max(0, minY / height - pad);
      return { x, y, w: Math.min(1, (maxX + 1) / width + pad) - x, h: Math.min(1, (maxY + 1) / height + pad) - y };
    }

    apply(box) {
      const imageWidth = this.image.offsetWidth;
      const imageHeight = this.image.offsetHeight;
      if (!imageWidth || !imageHeight) return;
      const style = getComputedStyle(this.stage);
      const areaWidth = this.stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const areaHeight = this.stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const contentWidth = box.w * imageWidth;
      const contentHeight = box.h * imageHeight;
      if (contentWidth <= 0 || contentHeight <= 0 || areaWidth <= 0 || areaHeight <= 0) return;
      const scale = Math.min(4, Math.max(1, Math.min(areaWidth / contentWidth, areaHeight / contentHeight)));
      this.image.dataset.zoomBox = JSON.stringify(box);
      if (scale < 1.03) {
        this.image.style.transform = '';
        this.image.dataset.zoomFit = '1';
        return;
      }
      const dx = (box.x + box.w / 2 - 0.5) * imageWidth;
      const dy = (box.y + box.h / 2 - 0.5) * imageHeight;
      this.image.style.transform = `translate(${(-dx * scale).toFixed(1)}px, ${(-dy * scale).toFixed(1)}px) scale(${scale.toFixed(3)})`;
      this.image.dataset.zoomFit = scale.toFixed(2);
    }
  }

  // V8.2 (2026-09-02): live product details. The catalog snapshot carries two pictures per
  // design; Shopify's public /products/<handle>.js carries every photo plus current sizes,
  // prices and stock, and allows cross-origin reads. When a design opens, the popup fetches
  // it once per handle, replaces the product's images and variants, and re-renders. Any
  // failure leaves the snapshot data in place; the popup never waits on this.
  class StorefrontProductDetails {
    constructor(modal, timeoutMs) {
      this.modal = modal;
      this.timeoutMs = Number(timeoutMs) || 6000;
      this.cache = new Map();
      if (!this.modal) return;
      document.addEventListener('dviy:product-modal-open', (event) => {
        try {
          this.refresh(event.detail && event.detail.product).catch(() => {});
        } catch (_error) {
          /* the snapshot data stays */
        }
      });
    }

    handleUrl(product) {
      try {
        const url = new URL(product.url, window.location.href);
        const match = url.pathname.match(/\/products\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/);
        return match ? `${url.origin}/products/${match[1]}.js` : null;
      } catch {
        return null;
      }
    }

    load(url) {
      if (this.cache.has(url)) return this.cache.get(url);
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), this.timeoutMs);
      const promise = fetch(url, { method: 'GET', headers: { Accept: 'application/json' }, mode: 'cors', credentials: 'omit', signal: controller.signal })
        .then((response) => (response.ok ? response.json() : null))
        .then((payload) => (recsApi ? recsApi.adaptStorefrontProduct(payload) : null))
        .catch(() => null)
        .finally(() => window.clearTimeout(timer));
      this.cache.set(url, promise);
      return promise;
    }

    async refresh(product) {
      if (!product || product.storefrontLoaded) return;
      const url = this.handleUrl(product);
      if (!url) return;
      const live = await this.load(url);
      if (!live) return;
      product.images = live.images;
      product.variants = live.variants;
      product.storefrontLoaded = true;
      if (this.modal.currentProduct === product) this.modal.refreshRenderedProduct();
    }
  }

  // V8.2 (2026-09-02, Gus): the browse paper sits on top of the island scene, which clips
  // its overflow, and the paper is now much taller than the scene (rails, shelves, 24 cards).
  // The scene's inline min-height follows the paper's bottom edge so nothing is ever cut;
  // the stylesheet minimum (max(170svh, 1450px)) still applies when the paper is small or
  // minimized. The scene's coloring canvas re-measures itself on resize.
  class ScenePaperFit {
    constructor(paper, gap) {
      this.paper = paper;
      this.scene = paper ? paper.closest('.story-scene') : null;
      this.gap = Number(gap) || 48;
      this.frame = 0;
      // The scene only grows during a visit (per viewport width): shrinking it would rescale
      // the coloring artwork behind the paper every time a filter, a page or a rail page
      // shows less content, which reads as the background jumping.
      this.highWater = 0;
      this.highWaterWidth = 0;
      if (!this.paper || !this.scene) return;
      const schedule = () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.fit();
        });
      };
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(this.paper);
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    }

    stylesheetMinimum() {
      return Math.max(1.7 * window.innerHeight, 1450);
    }

    fit() {
      if (this.highWaterWidth !== window.innerWidth) {
        this.highWaterWidth = window.innerWidth;
        this.highWater = 0;
      }
      const needed = this.paper.offsetTop + this.paper.offsetHeight + this.gap;
      this.highWater = Math.max(this.highWater, needed);
      const next = `${Math.round(Math.max(this.stylesheetMinimum(), this.highWater))}px`;
      if (this.scene.style.minHeight !== next) this.scene.style.minHeight = next;
    }
  }

  // V8.2 (2026-09-02, Gus): on desktop the rails are grids and show two rows per page with
  // Previous / Next in the heading row; on phones the sideways rail shows every tile and the
  // pager stays hidden. Re-evaluated after every render and on resize.
  class RailPager {
    constructor(rail, heading) {
      this.rail = rail;
      this.heading = heading;
      this.page = 0;
      this.frame = 0;
      if (!this.rail || !this.heading) return;
      this.pager = document.createElement('div');
      this.pager.className = 'design-shelf__pager';
      this.pager.hidden = true;
      this.prev = document.createElement('button');
      this.prev.type = 'button';
      this.prev.textContent = '‹ Previous';
      this.prev.setAttribute('aria-label', 'Previous designs');
      this.status = document.createElement('span');
      this.status.setAttribute('aria-live', 'polite');
      this.next = document.createElement('button');
      this.next.type = 'button';
      this.next.textContent = 'Next ›';
      this.next.setAttribute('aria-label', 'Next designs');
      this.pager.append(this.prev, this.status, this.next);
      this.heading.append(this.pager);
      this.prev.addEventListener('click', () => {
        this.page -= 1;
        this.update();
      });
      this.next.addEventListener('click', () => {
        this.page += 1;
        this.update();
      });
      const schedule = () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      new MutationObserver(() => {
        this.page = 0;
        schedule();
      }).observe(this.rail, { childList: true });
      window.addEventListener(
        'resize',
        () => {
          this.page = 0;
          schedule();
        },
        { passive: true },
      );
      schedule();
    }

    update() {
      const tiles = [...this.rail.children].filter((element) => element.classList.contains('design-tile'));
      const style = getComputedStyle(this.rail);
      if (style.display !== 'grid' || !tiles.length) {
        tiles.forEach((tile) => {
          tile.hidden = false;
        });
        this.rail.style.minHeight = '';
        this.pager.hidden = true;
        return;
      }
      const columns = Math.max(1, style.gridTemplateColumns.split(' ').filter(Boolean).length);
      const pageSize = columns * 2;
      const pages = Math.max(1, Math.ceil(tiles.length / pageSize));
      this.page = Math.min(Math.max(0, this.page), pages - 1);
      tiles.forEach((tile, index) => {
        tile.hidden = index < this.page * pageSize || index >= (this.page + 1) * pageSize;
      });
      // A shorter last page must not change the rail's height (the paper and the scene behind
      // it would move): the first, full page sets the height for every page.
      if (this.page === 0) {
        this.rail.style.minHeight = '';
        this.rail.style.minHeight = pages > 1 ? `${this.rail.offsetHeight}px` : '';
      }
      this.pager.hidden = pages <= 1;
      this.prev.disabled = this.page === 0;
      this.next.disabled = this.page >= pages - 1;
      this.status.textContent = `${this.page + 1} of ${pages}`;
    }
  }
  // V8.2 CATALOG, RAILS AND HEARTS — END

  // V8.2 (2026-09-02): Add to cart. On the store the Shopify template sets window.DVIY_CART,
  // and the selected size is posted to /cart/add.js, the cart count is read from /cart.js, and
  // a "View cart" link appears in the popup status and the top bar. Without that global (the
  // Netlify lab) the local prototype confirmation stays and nothing is written anywhere.
  class PrototypeCartFeedback {
    constructor(cartConfig) {
      this.timeout = 0;
      this.busy = false;
      this.cart =
        cartConfig && typeof cartConfig === 'object' && typeof cartConfig.addUrl === 'string' && typeof cartConfig.cartUrl === 'string'
          ? cartConfig
          : null;
      this.cartLink = document.querySelector('[data-cart-link]');
      document.querySelector('[data-v6-cart-intent]')?.addEventListener('submit', event => {
        event.preventDefault();
        event.stopPropagation();
      });
      this.cartCount = document.querySelector('[data-cart-count]');
      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-prototype-add]');
        if (!button || button.disabled) return;
        if (this.cart) {
          this.add().catch((error) => this.fail(error));
        } else {
          this.confirm();
        }
      });
      if (this.cart) {
        if (this.cartLink) this.cartLink.href = this.cart.cartUrl;
        this.refreshCount().catch(() => {});
      }
    }

    labels() {
      return [...document.querySelectorAll('[data-prototype-add-label]')];
    }

    setLabels(text) {
      this.labels().forEach((label) => {
        label.textContent = text;
      });
    }

    resetLabelsLater(ms) {
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => this.setLabels('Add to cart'), ms);
    }

    selection() {
      const modalOpen = Boolean(productModal?.modal?.open);
      const product = (modalOpen ? productModal.currentProduct : null) || productSticky?.currentProduct || productModal?.currentProduct;
      const variant = (modalOpen ? productModal.currentVariant : null) || productSticky?.currentVariant || productModal?.currentVariant;
      return { product, variant };
    }

    announce(message, withCartLink) {
      document.querySelectorAll('[data-prototype-cart-status]').forEach((status) => {
        status.textContent = message;
      });
      if (productModal?.status && productModal.modal.open) {
        productModal.status.textContent = message;
        if (withCartLink && this.cart) {
          const link = document.createElement('a');
          link.className = 'product-modal__cart-link';
          link.href = this.cart.cartUrl;
          link.textContent = 'View cart';
          productModal.status.append(' ', link);
        }
      }
    }

    showCartLink(count) {
      // V5 (2026-09-03): the V4 header shows the cart count; keep it in sync with adds from the popup.
      document.querySelectorAll('[data-coloring-cart-count]').forEach((node) => {
        node.textContent = String(count);
      });
      if (!this.cartLink) return;
      if (this.cartCount) this.cartCount.textContent = String(count);
      this.cartLink.hidden = count <= 0;
    }

    async refreshCount() {
      if (!this.cart || typeof this.cart.stateUrl !== 'string') return null;
      const response = await fetch(this.cart.stateUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const state = await response.json();
      const count = state && Number.isInteger(state.item_count) ? state.item_count : null;
      if (count !== null) this.showCartLink(count);
      return count;
    }

    async add() {
      const { product, variant } = this.selection();
      if (!product || !variant || this.busy) return;
      const variantId = Number(variant.id);
      if (!Number.isInteger(variantId) || variantId <= 0) throw new Error('this design has no size to add yet');
      // Announce the real Ajax purchase intent through the existing form contract.
      // Its observer verifies the subsequent cart delta; this emits no success event.
      const intentForm = syncV6PurchaseContext(product, variant);
      intentForm?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      const buttons = [...document.querySelectorAll('[data-prototype-add]')];
      const wasDisabled = buttons.map((button) => button.disabled);
      this.busy = true;
      buttons.forEach((button) => {
        button.disabled = true;
      });
      this.setLabels('Adding…');
      try {
        const response = await fetch(this.cart.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!response.ok) {
          let detail = '';
          try {
            const body = await response.json();
            detail = body.description || body.message || '';
          } catch (_error) {
            /* no readable body */
          }
          throw new Error(detail || `the store answered ${response.status}`);
        }
        let count = null;
        try {
          count = await this.refreshCount();
        } catch (_error) {
          count = null;
        }
        this.setLabels('Added ✓');
        this.announce(
          `${product.shortTitle}, ${variant.size}, added to your cart${count !== null ? ` (${count} item${count === 1 ? '' : 's'})` : ''}.`,
          true,
        );
        this.resetLabelsLater(2500);
        document.dispatchEvent(new CustomEvent('dviy:cart-added', { detail: { product, variant, count } }));
      } finally {
        this.busy = false;
        buttons.forEach((button, index) => {
          button.disabled = wasDisabled[index];
        });
      }
    }

    fail(error) {
      console.error('Add to cart failed.', error);
      this.setLabels('Add to cart');
      this.announce(`Sorry, that did not reach your cart (${error && error.message ? error.message : 'unknown error'}). Please try again.`, false);
    }

    confirm() {
      const { product, variant } = this.selection();
      if (!product || !variant) return;
      this.setLabels('Added');
      this.announce(`${product.shortTitle}, ${variant.size}, added to this local prototype cart.`, false);
      this.resetLabelsLater(1800);
    }
  }

  const paperMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

  class StoryPaperMinimizer {
    constructor(panel, index, status) {
      this.panel = panel;
      this.status = status;
      this.busy = false;
      this.expandedHeight = 0;
      this.heading = panel.querySelector('h1, h2, h3');
      this.label = this.heading?.textContent.replace(/\s+/g, ' ').trim() || `Story section ${index + 1}`;
      this.contentState = [...panel.children].map((element) => ({
        element,
        inert: Boolean(element.inert),
        ariaHidden: element.getAttribute('aria-hidden'),
      }));
      this.button = this.createButton();

      panel.classList.add('is-minimizable');
      panel.dataset.paperPanel = String(index + 1);
      panel.dataset.paperState = 'expanded';
      panel.append(this.button);
      this.scene = panel.closest('.story-scene');
      this.markerSlot = this.scene?.querySelector('[data-reveal-marker-slot]') || null;
      this.naturalButtonTop = this.button.offsetTop;
      this.button.addEventListener('click', () => this.toggle());
    }

    updateCornerCollision() {
      if (!this.markerSlot || window.innerWidth >= 700) {
        this.button.classList.remove('is-corner-stacked');
        this.button.style.removeProperty('--paper-corner-shift');
        return;
      }

      const slotRect = this.markerSlot.getBoundingClientRect();
      const panelRect = this.panel.getBoundingClientRect();
      const buttonHeight = this.button.offsetHeight;
      const naturalTop = panelRect.top + this.naturalButtonTop;
      const naturalBottom = naturalTop + buttonHeight;
      const gap = 8;
      const collides = naturalBottom > slotRect.top - gap && naturalTop < slotRect.bottom + gap;

      this.button.classList.toggle('is-corner-stacked', collides);
      if (collides) {
        const stackedTop = Math.min(slotRect.bottom + gap, window.innerHeight - buttonHeight - gap);
        this.button.style.setProperty('--paper-corner-shift', `${Math.round(stackedTop - naturalTop)}px`);
      } else {
        this.button.style.removeProperty('--paper-corner-shift');
      }
    }

    createButton() {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'paper__minimize';
      button.dataset.paperMinimize = '';
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', `Minimize ${this.label} panel`);
      button.title = `Minimize ${this.label} panel`;

      const disc = document.createElement('span');
      disc.className = 'paper__minimize-disc';
      disc.setAttribute('aria-hidden', 'true');

      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.classList.add('paper__minimize-icon');
      icon.setAttribute('viewBox', '0 0 16 16');
      icon.setAttribute('focusable', 'false');

      // Uses the Bootstrap Icons dash/plus geometry already established by the source product template.
      const horizontal = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      horizontal.setAttribute('d', 'M3 8h10');
      const vertical = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      vertical.classList.add('paper__minimize-icon-vertical');
      vertical.setAttribute('d', 'M8 3v10');
      icon.append(horizontal, vertical);
      disc.append(icon);
      button.append(disc);
      return button;
    }

    setContentUnavailable(unavailable) {
      this.contentState.forEach(({ element, inert, ariaHidden }) => {
        if (unavailable) {
          element.inert = true;
          element.setAttribute('aria-hidden', 'true');
          return;
        }

        element.inert = inert;
        if (ariaHidden === null) element.removeAttribute('aria-hidden');
        else element.setAttribute('aria-hidden', ariaHidden);
      });
    }

    applyState(minimized) {
      this.panel.classList.toggle('is-minimized', minimized);
      this.panel.dataset.paperState = minimized ? 'minimized' : 'expanded';
      this.button.setAttribute('aria-expanded', String(!minimized));
      this.button.setAttribute(
        'aria-label',
        `${minimized ? 'Restore' : 'Minimize'} ${this.label} panel`,
      );
      this.button.title = `${minimized ? 'Restore' : 'Minimize'} ${this.label} panel`;
      this.setContentUnavailable(minimized);
    }

    createGhost(minimizing) {
      const rect = this.panel.getBoundingClientRect();
      const buttonRect = this.button.getBoundingClientRect();
      if (minimizing) this.expandedHeight = rect.height;
      const expandedHeight = this.expandedHeight || rect.height;
      const ghost = this.panel.cloneNode(true);
      ghost.classList.remove('is-minimized');
      ghost.classList.add('paper-minimize-ghost');
      ghost.removeAttribute('id');
      ghost.removeAttribute('aria-labelledby');
      ghost.removeAttribute('data-paper-state');
      ghost.querySelector('[data-paper-minimize]')?.remove();
      ghost.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      // V5 scene (2026-09-04): the V4 hero has radio groups outside a form; a clone with the same names would steal their checked state.
      ghost.querySelectorAll('input, select, textarea').forEach((element) => element.removeAttribute('name'));
      ghost.setAttribute('aria-hidden', 'true');
      ghost.inert = true;
      Object.assign(ghost.style, {
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${expandedHeight}px`,
        transformOrigin: `${buttonRect.left + buttonRect.width / 2 - rect.left}px ${
          buttonRect.top + buttonRect.height / 2 - rect.top
        }px`,
      });
      document.body.append(ghost);
      return ghost;
    }

    keyframes() {
      const radius = getComputedStyle(this.panel).borderRadius || '28px';
      return [
        {
          offset: 0,
          opacity: 1,
          transform: 'translate3d(0, 0, 0) scale(1, 1) skewY(0deg)',
          clipPath: `inset(0% 0% 0% 0% round ${radius})`,
          filter: 'blur(0px)',
        },
        {
          offset: 0.38,
          opacity: 1,
          transform: 'translate3d(0, -2px, 0) scale(0.98, 0.82) skewY(-0.4deg)',
          clipPath: 'inset(0% 0% 9% 3% round 30px)',
          filter: 'blur(0px)',
        },
        {
          offset: 0.7,
          opacity: 0.9,
          transform: 'translate3d(0, -4px, 0) scale(0.64, 0.35) skewY(-1.6deg)',
          clipPath: 'inset(0% 0% 3% 32% round 36px)',
          filter: 'blur(0.15px)',
        },
        {
          offset: 0.9,
          opacity: 0.46,
          transform: 'translate3d(0, -6px, 0) scale(0.25, 0.13) skewY(-3deg)',
          clipPath: 'inset(0% 0% 0% 72% round 48px)',
          filter: 'blur(0.35px)',
        },
        {
          offset: 1,
          opacity: 0,
          transform: 'translate3d(0, -7px, 0) scale(0.06, 0.045) skewY(-4deg)',
          clipPath: 'inset(0% 0% 0% 93% round 50%)',
          filter: 'blur(0.5px)',
        },
      ];
    }

    async toggle() {
      if (this.busy) return;
      const minimizing = !this.panel.classList.contains('is-minimized');
      const shouldAnimate = !paperMotionPreference.matches && typeof this.panel.animate === 'function';
      const ghost = shouldAnimate ? this.createGhost(minimizing) : null;

      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      if (minimizing) this.applyState(true);

      if (ghost) {
        const animation = ghost.animate(this.keyframes(), {
          duration: minimizing ? 620 : 520,
          easing: minimizing ? 'cubic-bezier(0.55, 0.02, 0.28, 1)' : 'cubic-bezier(0.16, 1, 0.3, 1)',
          direction: minimizing ? 'normal' : 'reverse',
          fill: 'both',
        });
        try {
          await animation.finished;
        } catch {
          // The requested final state still applies if the browser cancels a visual-only animation.
        }
        ghost.remove();
      }

      if (!minimizing) this.applyState(false);
      this.button.removeAttribute('aria-busy');
      this.busy = false;
      if (this.status) this.status.textContent = `${this.label} panel ${minimizing ? 'minimized' : 'restored'}.`;
    }
  }

  const paperStatus = document.createElement('p');
  paperStatus.className = 'visually-hidden';
  paperStatus.setAttribute('role', 'status');
  paperStatus.setAttribute('aria-live', 'polite');
  document.body.append(paperStatus);
  const paperMinimizers = [...document.querySelectorAll('.paper')].map(
    (panel, index) => new StoryPaperMinimizer(panel, index, paperStatus),
  );
  let paperCornerFrame = 0;
  const updatePaperCornerCollisions = () => {
    paperCornerFrame = 0;
    paperMinimizers.forEach((minimizer) => minimizer.updateCornerCollision());
  };
  const schedulePaperCornerCollisionUpdate = () => {
    if (paperCornerFrame) return;
    paperCornerFrame = requestAnimationFrame(updatePaperCornerCollisions);
  };
  window.addEventListener('scroll', schedulePaperCornerCollisionUpdate, { passive: true });
  window.addEventListener('resize', schedulePaperCornerCollisionUpdate, { passive: true });
  schedulePaperCornerCollisionUpdate();

  productFinder = new CollectionProductFinder(document.querySelector('.paper--products'), loadDesignCatalog);
  productModal = new CollectionProductModal(document.querySelector('[data-product-modal]'), loadProductCatalog);
  productSticky = new ProductStickyBar(document.querySelector('[data-product-sticky]'), loadProductCatalog);
  productRecommendations = new ProductModalRecommendations(
    document.querySelector('[data-product-modal]'),
    loadProductCatalog,
    window.DVIY_RECOMMENDATIONS_MODULE,
    window.DVIY_RECOMMENDATIONS,
  );
  productBrowseRecommendations = new BrowseRecommendationsRail(document.querySelector('.paper--products'));
  productRecentlyViewed = new RecentlyViewedRail(document.querySelector('.paper--products'), loadDesignCatalog, loadProductCatalog);
  productZoomFitter = new ZoomImageFitter(document.querySelector('[data-product-image-zoom]'));
  productStorefrontDetails = new StorefrontProductDetails(productModal, 6000);
  productScenePaperFit = new ScenePaperFit(document.querySelector('.paper--products'), 48);
  productRailPagers = [
    [document.querySelector('[data-product-modal-recommendations-rail]'), document.querySelector('[data-product-modal-recommendations] .design-shelf__heading')],
    [document.querySelector('[data-browse-recommendations-rail]'), document.querySelector('[data-browse-recommendations] .design-shelf__heading')],
    [document.querySelector('[data-recently-viewed-rail]'), document.querySelector('[data-recently-viewed] .design-shelf__heading')],
  ].map(([rail, heading]) => new RailPager(rail, heading));
  prototypeCart = new PrototypeCartFeedback(window.DVIY_CART);

  // V6: standalone products seed from their published custom.page_id.
  // Legacy selections retain the static catalog path; numbered variants retain their product
  // identity so changing size never falls back to an unrelated design.
  (() => {
    const heroRoot = document.querySelector('[data-coloring-page]');
    if (!heroRoot || !recsApi || !productRecommendations?.client) return;
    let revision = 0;
    let seededCode = '';
    const standalonePageId = recsApi.normalize(heroRoot.dataset.standaloneProductPageId || '');
    const standaloneProduct = /^generic-coloring-blanket-p[0-9]+$/.test(standalonePageId)
      ? {
          id: heroRoot.dataset.standaloneProductId || `standalone-${standalonePageId}`,
          designCode: standalonePageId,
          shortTitle: heroRoot.dataset.standaloneProductTitle || 'Coloring Blanket',
          title: heroRoot.dataset.standaloneProductTitle || 'Coloring Blanket',
          url: window.location.href,
          images: [],
          variants: [],
          recommendationOnly: true,
          standaloneRecommendationSource: true,
        }
      : null;
    const clear = () => {
      productRecommendations.token += 1;
      productRecommendations.client.cancel();
      productRecommendations.clear();
      productRecommendations.announce(null, []);
    };
    const seed = async (design) => {
      const currentRevision = ++revision;
      const code = recsApi.normalize(design?.designCode || '');
      if (!code) {
        seededCode = '';
        clear();
        return;
      }
      if (code === seededCode) return;
      clear();
      try {
        if (standaloneProduct && code === standalonePageId) {
          seededCode = code;
          await productRecommendations.refresh(standaloneProduct);
          return;
        }
        const index = await loadDesignCatalog();
        if (currentRevision !== revision) return;
        const entry = index?.byCode?.get(code);
        if (!entry?.product) { seededCode = ''; return; }
        seededCode = code;
        productRecentlyViewed?.record(entry.product);
        await productRecommendations.refresh(entry.product);
      } catch (error) {
        if (currentRevision === revision) {
          seededCode = '';
          clear();
          console.debug('Hero recommendations unavailable.', error);
        }
      }
    };
    heroRoot.addEventListener('coloring:design-change', event => seed(event.detail?.design));
    // Numbered swatches update the existing hero controller without a catalog event.
    heroRoot.addEventListener('change', event => {
      if (event.target.matches('[data-coloring-option-input][data-option-position="2"]')) {
        seed(standaloneProduct || heroRoot.coloringBlanket?.design);
      }
    });
    // A popup selection supersedes an in-flight hero catalog lookup.
    document.addEventListener('dviy:product-modal-open', () => { revision += 1; seededCode = ''; });
    const seedInitialHero = () => seed(standaloneProduct || heroRoot.coloringBlanket?.design);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', seedInitialHero, { once: true });
    } else seedInitialHero();
  })();

  const designSearchForm = document.querySelector('[data-design-search]');
  const designSearchInput = designSearchForm?.querySelector('input[type="search"]');

  designSearchInput?.addEventListener('input', () => designSearchInput.setCustomValidity(''));

  designSearchForm?.addEventListener('submit', (event) => {
    const input = designSearchInput;
    input.value = input.value.trim();
    if (!input.value) {
      event.preventDefault();
      input.setCustomValidity('Enter a design idea to search.');
      input.reportValidity();
      input.focus();
      return;
    }
    input.setCustomValidity('');
  });

  document.querySelectorAll('[data-scene-image]').forEach((image) => {
    const fallback = image.closest('.story-scene')?.querySelector('.story-scene__fallback');
    image.addEventListener('load', () => {
      image.classList.remove('is-error');
      if (fallback) fallback.hidden = true;
    });
    image.addEventListener('error', () => {
      image.classList.add('is-error');
      if (fallback) fallback.hidden = false;
    });
  });

  updateButtons();
  renderSaved();
})();
